!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Swan = t() : e.Swan = t();
}(window, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var i = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        r.d(n, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 32);
  }([function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      function e() {}

      return e.prototype.deserialiseDictionary = function (e, t, r) {
        var n = new Map();

        for (var i in e) {
          if (e.hasOwnProperty(i)) {
            var o = e[i],
                a = t(i),
                s = r(o);
            n.set(a, s);
          }
        }

        return n;
      }, e;
    }();

    t.RestDeserialiser = n;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e = function e(t, r) {
        return (_e = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(t) {
        var r = e.call(this) || this;
        return r.property = t, r;
      }

      return n(t, e), t.isChangedIntermediateProperty = function (e) {
        return e instanceof t;
      }, t;
    }(r(15).IntermediateProperty);

    t.ChangedIntermediateProperty = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      return function () {};
    }();

    t.DataTransformer = n;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(1),
        i = function () {
      function e() {}

      return e.prototype.combineProperty = function (e, t) {
        return n.ChangedIntermediateProperty.isChangedIntermediateProperty(e) ? e.property : t;
      }, e.prototype.combineSubObject = function (e, t, r) {
        return n.ChangedIntermediateProperty.isChangedIntermediateProperty(e) ? r(t, e.property) : t;
      }, e.prototype.combineOptionalSubObject = function (e, t, r, i) {
        if (n.ChangedIntermediateProperty.isChangedIntermediateProperty(e)) {
          if (void 0 === e.property) return;
          return void 0 === t ? i(e.property) : r(t, e.property);
        }

        return t;
      }, e;
    }();

    t.PushDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(17),
        i = r(86),
        o = r(87),
        a = r(1),
        s = function () {
      function e(e) {
        var t = this;
        this.getString = function (e) {
          return e;
        }, this.getOptionalString = function (e) {
          return t.getOptional(e, t.getString);
        }, this.getBoolean = function (e) {
          return "true" === e;
        }, this.getInt = function (e) {
          return parseInt(e, 10);
        }, this.getOptionalInt = function (e) {
          return t.getOptional(e, t.getInt);
        }, this.getNumber = function (e) {
          return parseFloat(e);
        }, this.getOptionalNumber = function (e) {
          return t.getOptional(e, t.getNumber);
        }, this.getDate = function (e) {
          return new Date(e);
        }, this.getOptionalDate = function (e) {
          return t.getOptional(e, t.getDate);
        }, this.getBig = function (e) {
          return new n.default(e);
        }, this.getArray = function (e) {
          return JSON.parse(e);
        }, this.getProductType = function (e) {
          return t.getInt(e);
        }, this.getSettlementType = function (e) {
          return t.getInt(e);
        }, this.getTradeRejectionReason = function (e) {
          return t.getInt(e);
        }, this.getOrderRejectionReason = function (e) {
          return t.getInt(e);
        }, this.getOrderType = function (e) {
          return t.getInt(e);
        }, this.getOrderStatus = function (e) {
          return t.getInt(e);
        }, this.getTradeStatus = function (e) {
          return t.getInt(e);
        }, this.getTradeSubType = function (e) {
          return t.getInt(e);
        }, this.getPositionStatus = function (e) {
          return t.getInt(e);
        }, this.getExchangeSubscriptionStatus = function (e) {
          return t.getInt(e);
        }, this.getSubscriptionFrequency = function (e) {
          return t.getInt(e);
        }, this.getUnderlyingType = function (e) {
          return t.getInt(e);
        }, this.getDistanceType = function (e) {
          return t.getInt(e);
        }, this.getLifecycleType = function (e) {
          return t.getInt(e);
        }, this.fieldNameProvider = e;
      }

      return e.prototype.getWrappedValue = function (e, t, r) {
        return t.isValueChanged(e) || null === t.getValue(e) ? this.getWrappedChangedValue(e, t, r) : new o.UnchangedIntermediateProperty();
      }, e.prototype.getWrappedChangedValue = function (e, t, r) {
        return new a.ChangedIntermediateProperty(this.getValue(e, t, r));
      }, e.prototype.getWrappedChangedValueFromObject = function (e) {
        return new a.ChangedIntermediateProperty(e);
      }, e.prototype.getValue = function (e, t, r) {
        return r(t.getValue(e));
      }, e.prototype.isValueUndefined = function (e, t) {
        var r = t.getValue(e);
        return this.isUndefined(r);
      }, e.prototype.getFromJson = function (e) {
        return JSON.parse(e);
      }, e.prototype.getOptional = function (e, t) {
        if (!this.isUndefined(e)) return t(e);
      }, e.prototype.isUndefined = function (e) {
        return null === e || 0 === e.length;
      }, e.prototype.getDeserialisationResult = function (e, t) {
        var r = this.getSequenceNumber(t),
            n = this.getKey(t);
        return new i.DeserialisationResult(e, r, n, t);
      }, e.prototype.getSequenceNumber = function (e) {
        return {
          Era: this.getValue(this.fieldNameProvider.sequenceNumberEra, e, this.getBig),
          Number: this.getValue(this.fieldNameProvider.sequenceNumberNumber, e, this.getBig)
        };
      }, e.prototype.getKey = function (e) {
        return e.getValue(this.fieldNameProvider.itemKey);
      }, e.prototype.getWrappedInIntermediateProperty = function (e) {
        return void 0 === e ? new a.ChangedIntermediateProperty(e) : Object.keys(e).find(function (t) {
          return e[t] instanceof a.ChangedIntermediateProperty;
        }) ? new a.ChangedIntermediateProperty(e) : new o.UnchangedIntermediateProperty();
      }, e;
    }();

    t.PushDeserialiser = s;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      return function () {
        this.itemKey = "key", this.sequenceNumberEra = "sequencenumber.era", this.sequenceNumberNumber = "sequencenumber.number";
      };
    }();

    t.FieldNameProvider = n;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e2 = function e(t, r) {
        return (_e2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e2(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.InstructionKeyRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e3 = function e(t, r) {
        return (_e3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e3(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Key)) return {
          Key: e.Key.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.InstructionKeyDataTransformer = a;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Add = 1] = "Add", e[e.Update = 2] = "Update", e[e.Delete = 3] = "Delete", e[e.Distinct = 4] = "Distinct";
    }(t.StreamUpdateType || (t.StreamUpdateType = {}));
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e4 = function e(t, r) {
        return (_e4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e4(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Orders)) return {
          Orders: e.Orders.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.OrderGroupingDataTransformer = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e5 = function e(t, r) {
        return (_e5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e5(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Key: this.combineProperty(t.Key, e.Key)
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.InstructionKeyDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e6 = function e(t, r) {
        return (_e6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e6(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          IsoCode: e.IsoCode,
          Symbol: e.Symbol,
          Exponent: e.Exponent,
          Key: e.Key
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.CurrencyRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e7 = function e(t, r) {
        return (_e7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e7(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(137),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.considerationValueRestDeserialiser = new o.ConsiderationValueRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          BaseConsideration: null !== e.BaseConsideration ? this.considerationValueRestDeserialiser.deserialise(e.BaseConsideration) : void 0,
          DeliveryConsideration: null !== e.DeliveryConsideration ? this.considerationValueRestDeserialiser.deserialise(e.DeliveryConsideration) : void 0
        };
      }, t;
    }(i.RestDeserialiser);

    t.ConsiderationRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(8);
    t.StreamUpdateType = n.StreamUpdateType;
    var i = r(14);
    t.PushConnectionError = i.PushConnectionError;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.AuthenticationError = 1] = "AuthenticationError", e[e.ServerError = 2] = "ServerError";
    }(t.PushConnectionError || (t.PushConnectionError = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      return function () {};
    }();

    t.IntermediateProperty = n;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e8 = function e(t, r) {
        return (_e8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e8(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Value) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId)) return {
          Value: e.Value.property,
          CurrencyId: e.CurrencyId.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.ConsiderationValueDataTransformer = a;
  }, function (e, t, r) {
    var n;
    !function (i) {
      "use strict";

      var o,
          a = 20,
          s = 1,
          u = 1e6,
          c = -7,
          d = 21,
          p = "[big.js] ",
          l = p + "Invalid ",
          h = l + "decimal places",
          y = l + "rounding mode",
          f = {},
          g = void 0,
          m = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;

      function P(e, t, r, n) {
        var i = e.c,
            o = e.e + t + 1;

        if (o < i.length) {
          if (1 === r) n = i[o] >= 5;else if (2 === r) n = i[o] > 5 || 5 == i[o] && (n || o < 0 || i[o + 1] !== g || 1 & i[o - 1]);else if (3 === r) n = n || i[o] !== g || o < 0;else if (n = !1, 0 !== r) throw Error(y);
          if (o < 1) i.length = 1, n ? (e.e = -t, i[0] = 1) : i[0] = e.e = 0;else {
            if (i.length = o--, n) for (; ++i[o] > 9;) {
              i[o] = 0, o-- || (++e.e, i.unshift(1));
            }

            for (o = i.length; !i[--o];) {
              i.pop();
            }
          }
        } else if (r < 0 || r > 3 || r !== ~~r) throw Error(y);

        return e;
      }

      function v(e, t, r, n) {
        var i,
            o,
            a = e.constructor,
            s = !e.c[0];

        if (r !== g) {
          if (r !== ~~r || r < (3 == t) || r > u) throw Error(3 == t ? l + "precision" : h);

          for (r = n - (e = new a(e)).e, e.c.length > ++n && P(e, r, a.RM), 2 == t && (n = e.e + r + 1); e.c.length < n;) {
            e.c.push(0);
          }
        }

        if (i = e.e, r = (o = e.c.join("")).length, 2 != t && (1 == t || 3 == t && n <= i || i <= a.NE || i >= a.PE)) o = o.charAt(0) + (r > 1 ? "." + o.slice(1) : "") + (i < 0 ? "e" : "e+") + i;else if (i < 0) {
          for (; ++i;) {
            o = "0" + o;
          }

          o = "0." + o;
        } else if (i > 0) {
          if (++i > r) for (i -= r; i--;) {
            o += "0";
          } else i < r && (o = o.slice(0, i) + "." + o.slice(i));
        } else r > 1 && (o = o.charAt(0) + "." + o.slice(1));
        return e.s < 0 && (!s || 4 == t) ? "-" + o : o;
      }

      f.abs = function () {
        var e = new this.constructor(this);
        return e.s = 1, e;
      }, f.cmp = function (e) {
        var t,
            r = this,
            n = r.c,
            i = (e = new r.constructor(e)).c,
            o = r.s,
            a = e.s,
            s = r.e,
            u = e.e;
        if (!n[0] || !i[0]) return n[0] ? o : i[0] ? -a : 0;
        if (o != a) return o;
        if (t = o < 0, s != u) return s > u ^ t ? 1 : -1;

        for (a = (s = n.length) < (u = i.length) ? s : u, o = -1; ++o < a;) {
          if (n[o] != i[o]) return n[o] > i[o] ^ t ? 1 : -1;
        }

        return s == u ? 0 : s > u ^ t ? 1 : -1;
      }, f.div = function (e) {
        var t = this,
            r = t.constructor,
            n = t.c,
            i = (e = new r(e)).c,
            o = t.s == e.s ? 1 : -1,
            a = r.DP;
        if (a !== ~~a || a < 0 || a > u) throw Error(h);
        if (!i[0]) throw Error("[big.js] Division by zero");
        if (!n[0]) return new r(0 * o);
        var s,
            c,
            d,
            p,
            l,
            y = i.slice(),
            f = s = i.length,
            m = n.length,
            v = n.slice(0, s),
            _ = v.length,
            O = e,
            C = O.c = [],
            b = 0,
            T = a + (O.e = t.e - e.e) + 1;

        for (O.s = o, o = T < 0 ? 0 : T, y.unshift(0); _++ < s;) {
          v.push(0);
        }

        do {
          for (d = 0; d < 10; d++) {
            if (s != (_ = v.length)) p = s > _ ? 1 : -1;else for (l = -1, p = 0; ++l < s;) {
              if (i[l] != v[l]) {
                p = i[l] > v[l] ? 1 : -1;
                break;
              }
            }
            if (!(p < 0)) break;

            for (c = _ == s ? i : y; _;) {
              if (v[--_] < c[_]) {
                for (l = _; l && !v[--l];) {
                  v[l] = 9;
                }

                --v[l], v[_] += 10;
              }

              v[_] -= c[_];
            }

            for (; !v[0];) {
              v.shift();
            }
          }

          C[b++] = p ? d : ++d, v[0] && p ? v[_] = n[f] || 0 : v = [n[f]];
        } while ((f++ < m || v[0] !== g) && o--);

        return C[0] || 1 == b || (C.shift(), O.e--), b > T && P(O, a, r.RM, v[0] !== g), O;
      }, f.eq = function (e) {
        return !this.cmp(e);
      }, f.gt = function (e) {
        return this.cmp(e) > 0;
      }, f.gte = function (e) {
        return this.cmp(e) > -1;
      }, f.lt = function (e) {
        return this.cmp(e) < 0;
      }, f.lte = function (e) {
        return this.cmp(e) < 1;
      }, f.minus = f.sub = function (e) {
        var t,
            r,
            n,
            i,
            o = this,
            a = o.constructor,
            s = o.s,
            u = (e = new a(e)).s;
        if (s != u) return e.s = -u, o.plus(e);
        var c = o.c.slice(),
            d = o.e,
            p = e.c,
            l = e.e;
        if (!c[0] || !p[0]) return p[0] ? (e.s = -u, e) : new a(c[0] ? o : 0);

        if (s = d - l) {
          for ((i = s < 0) ? (s = -s, n = c) : (l = d, n = p), n.reverse(), u = s; u--;) {
            n.push(0);
          }

          n.reverse();
        } else for (r = ((i = c.length < p.length) ? c : p).length, s = u = 0; u < r; u++) {
          if (c[u] != p[u]) {
            i = c[u] < p[u];
            break;
          }
        }

        if (i && (n = c, c = p, p = n, e.s = -e.s), (u = (r = p.length) - (t = c.length)) > 0) for (; u--;) {
          c[t++] = 0;
        }

        for (u = t; r > s;) {
          if (c[--r] < p[r]) {
            for (t = r; t && !c[--t];) {
              c[t] = 9;
            }

            --c[t], c[r] += 10;
          }

          c[r] -= p[r];
        }

        for (; 0 === c[--u];) {
          c.pop();
        }

        for (; 0 === c[0];) {
          c.shift(), --l;
        }

        return c[0] || (e.s = 1, c = [l = 0]), e.c = c, e.e = l, e;
      }, f.mod = function (e) {
        var t,
            r = this,
            n = r.constructor,
            i = r.s,
            o = (e = new n(e)).s;
        if (!e.c[0]) throw Error("[big.js] Division by zero");
        return r.s = e.s = 1, t = 1 == e.cmp(r), r.s = i, e.s = o, t ? new n(r) : (i = n.DP, o = n.RM, n.DP = n.RM = 0, r = r.div(e), n.DP = i, n.RM = o, this.minus(r.times(e)));
      }, f.plus = f.add = function (e) {
        var t,
            r = this,
            n = r.constructor,
            i = r.s,
            o = (e = new n(e)).s;
        if (i != o) return e.s = -o, r.minus(e);
        var a = r.e,
            s = r.c,
            u = e.e,
            c = e.c;
        if (!s[0] || !c[0]) return c[0] ? e : new n(s[0] ? r : 0 * i);

        if (s = s.slice(), i = a - u) {
          for (i > 0 ? (u = a, t = c) : (i = -i, t = s), t.reverse(); i--;) {
            t.push(0);
          }

          t.reverse();
        }

        for (s.length - c.length < 0 && (t = c, c = s, s = t), i = c.length, o = 0; i; s[i] %= 10) {
          o = (s[--i] = s[i] + c[i] + o) / 10 | 0;
        }

        for (o && (s.unshift(o), ++u), i = s.length; 0 === s[--i];) {
          s.pop();
        }

        return e.c = s, e.e = u, e;
      }, f.pow = function (e) {
        var t = this,
            r = new t.constructor(1),
            n = r,
            i = e < 0;
        if (e !== ~~e || e < -1e6 || e > 1e6) throw Error(l + "exponent");

        for (i && (e = -e); 1 & e && (n = n.times(t)), e >>= 1;) {
          t = t.times(t);
        }

        return i ? r.div(n) : n;
      }, f.round = function (e, t) {
        var r = this.constructor;
        if (e === g) e = 0;else if (e !== ~~e || e < 0 || e > u) throw Error(h);
        return P(new r(this), e, t === g ? r.RM : t);
      }, f.sqrt = function () {
        var e,
            t,
            r,
            n = this,
            i = n.constructor,
            o = n.s,
            a = n.e,
            s = new i(.5);
        if (!n.c[0]) return new i(n);
        if (o < 0) throw Error(p + "No square root");
        0 === (o = Math.sqrt(n.toString())) || o === 1 / 0 ? ((t = n.c.join("")).length + a & 1 || (t += "0"), (e = new i(Math.sqrt(t).toString())).e = ((a + 1) / 2 | 0) - (a < 0 || 1 & a)) : e = new i(o.toString()), a = e.e + (i.DP += 4);

        do {
          r = e, e = s.times(r.plus(n.div(r)));
        } while (r.c.slice(0, a).join("") !== e.c.slice(0, a).join(""));

        return P(e, i.DP -= 4, i.RM);
      }, f.times = f.mul = function (e) {
        var t,
            r = this,
            n = r.constructor,
            i = r.c,
            o = (e = new n(e)).c,
            a = i.length,
            s = o.length,
            u = r.e,
            c = e.e;
        if (e.s = r.s == e.s ? 1 : -1, !i[0] || !o[0]) return new n(0 * e.s);

        for (e.e = u + c, a < s && (t = i, i = o, o = t, c = a, a = s, s = c), t = new Array(c = a + s); c--;) {
          t[c] = 0;
        }

        for (u = s; u--;) {
          for (s = 0, c = a + u; c > u;) {
            s = t[c] + o[u] * i[c - u - 1] + s, t[c--] = s % 10, s = s / 10 | 0;
          }

          t[c] = (t[c] + s) % 10;
        }

        for (s ? ++e.e : t.shift(), u = t.length; !t[--u];) {
          t.pop();
        }

        return e.c = t, e;
      }, f.toExponential = function (e) {
        return v(this, 1, e, e);
      }, f.toFixed = function (e) {
        return v(this, 2, e, this.e + e);
      }, f.toPrecision = function (e) {
        return v(this, 3, e, e - 1);
      }, f.toString = function () {
        return v(this);
      }, f.valueOf = f.toJSON = function () {
        return v(this, 4);
      }, (o = function e() {
        function t(r) {
          var n = this;
          if (!(n instanceof t)) return r === g ? e() : new t(r);
          r instanceof t ? (n.s = r.s, n.e = r.e, n.c = r.c.slice()) : function (e, t) {
            var r, n, i;
            if (0 === t && 1 / t < 0) t = "-0";else if (!m.test(t += "")) throw Error(l + "number");

            for (e.s = "-" == t.charAt(0) ? (t = t.slice(1), -1) : 1, (r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), i = t.length, n = 0; n < i && "0" == t.charAt(n);) {
              ++n;
            }

            if (n == i) e.c = [e.e = 0];else {
              for (; i > 0 && "0" == t.charAt(--i);) {
                ;
              }

              for (e.e = r - n - 1, e.c = [], r = 0; n <= i;) {
                e.c[r++] = +t.charAt(n++);
              }
            }
          }(n, r), n.constructor = t;
        }

        return t.prototype = f, t.DP = a, t.RM = s, t.NE = c, t.PE = d, t.version = "5.0.2", t;
      }()).default = o.Big = o, void 0 === (n = function () {
        return o;
      }.call(t, r, t, e)) || (e.exports = n);
    }();
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Connecting = 1] = "Connecting", e[e.Connected = 2] = "Connected", e[e.Reconnecting = 3] = "Reconnecting", e[e.Disconnected = 4] = "Disconnected";
    }(t.PushConnectionStatus || (t.PushConnectionStatus = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(110),
        i = function () {
      function e(e, t, r, i, o) {
        var a = this;
        this.subscription = new n.DeserialisingPushSubscription(e, t, r, function (e) {
          return a.onDeserialisedUpdate(e);
        }, function () {
          return a.onSubscription();
        }), this.onStarted = o, this.onUpdate = i;
      }

      return e.prototype.start = function () {
        this.subscription.start();
      }, e.prototype.stop = function () {
        this.subscription.stop();
      }, e.prototype.onSubscription = function () {
        this.onStarted && this.onStarted();
      }, e;
    }();

    t.PushStreamBase = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      function e(e) {
        this.pushClient = e;
      }

      return e.prototype.start = function () {
        void 0 === this.subscription && (this.subscription = this.createSubscription(), this.pushClient.subscribe(this.subscription));
      }, e.prototype.stop = function () {
        void 0 !== this.subscription && (this.pushClient.unsubscribe(this.subscription), this.subscription = void 0);
      }, e;
    }();

    t.PushSubscriptionBase = n;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e9 = function e(t, r) {
        return (_e9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e9(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        i = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(8),
        s = r(111),
        u = r(24),
        c = r(25),
        d = function (e) {
      function t(t, r, n, i, o, a, s, u, d) {
        var p = e.call(this, t, r, n, o, new c.UpdatingDataStore(i), a) || this;
        if (void 0 === u && void 0 === d) throw new Error("Data transformer required for streams using push snapshot");
        if (void 0 !== u && void 0 !== d) throw new Error("Data transformer not required for streams using REST snapshot");
        return p.dataCombiner = i, p.requestSnapshot = u, p.dataTransformer = d, p.keyExtractor = s, p;
      }

      return n(t, e), t.prototype.getSnapshot = function () {
        return i(this, void 0, void 0, function () {
          var e, t;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return void 0 === this.requestSnapshot ? [2] : (this.snapshotManager = new s.FixedStructureSnapshotManager(this.requestSnapshot, this.keyExtractor, this.dataCombiner), [4, this.getSnapshotEraResult()]);

              case 1:
                return (e = r.sent()).success ? (t = e.snapshot, void 0 === this.snapshotManager ? [2] : (this.snapshotManager = void 0, [2, t])) : [2];
            }
          });
        });
      }, t.prototype.getSnapshotAndForwardUpdates = function () {
        return i(this, void 0, void 0, function () {
          var e, t, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.getSnapshot()];

              case 1:
                return void 0 === (e = n.sent()) ? [2] : (this.dataStore.setInitialData(e), (t = Array.from(e.values())).length > 0 && this.updateEra(t[0].sequenceNumber.Era), r = t.map(function (e) {
                  return {
                    update: e.data,
                    type: a.StreamUpdateType.Add
                  };
                }), this.onUpdate(r), [2]);
            }
          });
        });
      }, t.prototype.onDeserialisedUpdate = function (e) {
        if (!this.handleChangeInEra(e.sequenceNumber.Era)) if (void 0 === this.snapshotManager) {
          if (void 0 === this.requestSnapshot && !this.dataStore.has(e.key)) {
            if (void 0 === this.dataTransformer) throw new Error("No data transformer to transformer push data to full object");
            var t = {
              key: e.key,
              data: this.dataTransformer.transform(e.result),
              sequenceNumber: e.sequenceNumber
            },
                r = this.dataStore.clear();
            return r.set(e.key, t), this.dataStore.setInitialData(r), void this.onUpdate([{
              update: t.data,
              type: a.StreamUpdateType.Add
            }]);
          }

          var n = this.dataStore.update(e.key, e.result, e.sequenceNumber);
          this.onUpdate([{
            update: n.data,
            type: a.StreamUpdateType.Update
          }]);
        } else this.snapshotManager.processUpdate(e.key, e.result, e.sequenceNumber, a.StreamUpdateType.Update);
      }, t.prototype.onSubscription = function () {
        return i(this, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e.prototype.onSubscription.call(this), [4, this.getSnapshotAndForwardUpdates()];

              case 1:
                return t.sent(), [2];
            }
          });
        });
      }, t;
    }(u.EraAwarePushStream);

    t.MergePushStream = d;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(112),
        i = r(23),
        o = function () {
      function e(e, t, r) {
        this.requestSnapshot = e, this.keySelector = t, this.dataCombiner = r, this.sequenceNumberSorter = new n.SequenceNumberSorter(function (e) {
          return e.sequenceNumber;
        }), this.updates = [];
      }

      return e.prototype.processUpdate = function (e, t, r, n) {
        this.updates.push({
          key: e,
          intermediate: t,
          sequenceNumber: r,
          type: n
        });
      }, e.prototype.convertSnapshotToVersionData = function (e) {
        var t = this;
        return (e instanceof Array ? e : [e]).map(function (e) {
          return {
            key: t.keySelector(e.Content),
            data: e.Content,
            sequenceNumber: e.SequenceNumber
          };
        });
      }, e.prototype.validateSnapshotToUpdates = function (e) {
        var t = this.updates.filter(function (e) {
          return !e.sequenceNumber.Era.eq(0);
        }).map(function (e) {
          return e.sequenceNumber.Era;
        }),
            r = e.filter(function (e) {
          return !e.sequenceNumber.Era.eq(0);
        }).map(function (e) {
          return e.sequenceNumber.Era;
        }),
            n = t.concat(r),
            o = new Set(n.map(function (e) {
          return e.toString();
        }));
        if (o.size > 1) throw new i.EraMismatchError("Snapshot data era values mismatch between REST and Push. Received Eras=" + Array.from(o));
      }, e;
    }();

    t.SnapshotManager = o;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e10 = function e(t, r) {
        return (_e10 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e10(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(r) {
        var n = this.constructor,
            i = e.call(this, r) || this;
        return Object.setPrototypeOf(i, n.prototype), i.name = t.name, i;
      }

      return n(t, e), t;
    }(Error);

    t.EraMismatchError = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e11 = function e(t, r) {
        return (_e11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e11(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        i = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(19),
        s = r(113),
        u = r(13),
        c = r(23),
        d = function (e) {
      function t(t, r, n, i, o, a) {
        var u = e.call(this, t, r, n, i, a) || this;
        return u.snapshotManager = void 0, u.eraManager = new s.EraManager(), u.dataStore = o, u;
      }

      return n(t, e), t.prototype.stop = function () {
        e.prototype.stop.call(this), this.snapshotManager = void 0, this.eraManager.clear(), this.dataStore.clear();
      }, t.prototype.updateEra = function (e) {
        this.eraManager.update(e);
      }, t.prototype.handleChangeInEra = function (e) {
        if (!this.eraManager.updateAndCheckIsEraValid(e)) {
          var t = this.getEntriesAndStop();
          return this.onUpdate(Array.from(t.values()).map(function (e) {
            return {
              update: e.data,
              type: u.StreamUpdateType.Delete
            };
          })), this.start(), !0;
        }

        return !1;
      }, t.prototype.getEntriesAndStop = function () {
        var e = this.dataStore.clear();
        return this.stop(), e;
      }, t.prototype.getSnapshotEraResult = function () {
        return i(this, void 0, void 0, function () {
          var e, t;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return r.trys.push([0, 2,, 3]), [4, this.snapshotManager.getInitialData()];

              case 1:
                return e = r.sent(), [3, 3];

              case 2:
                switch ((t = r.sent()).constructor) {
                  case c.EraMismatchError:
                    return this.stop(), this.start(), [2, {
                      success: !1
                    }];

                  default:
                    throw t;
                }

                return [3, 3];

              case 3:
                return [2, {
                  snapshot: e,
                  success: !0
                }];
            }
          });
        });
      }, t;
    }(a.PushStreamBase);

    t.EraAwarePushStream = d;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      function e(e) {
        this.dataCombiner = e, this.currentData = new Map();
      }

      return e.prototype.update = function (e, t, r) {
        var n = this.currentData.get(e);
        if (void 0 === n) throw new Error('No existing value for key "' + e + '"');
        var i = {
          key: e,
          data: this.dataCombiner.combine(n.data, t),
          sequenceNumber: r
        };
        return this.currentData.set(e, i), i;
      }, e.prototype.remove = function (e, t, r) {
        var n = this.currentData.get(e);
        if (void 0 === n) throw new Error('No existing value for key "' + e + '"');
        var i = this.dataCombiner.combine(n.data, t);
        return this.currentData.delete(e), {
          key: e,
          data: i,
          sequenceNumber: r
        };
      }, e.prototype.tryRemove = function (e) {
        return this.currentData.delete(e);
      }, e.prototype.setInitialData = function (e) {
        var t = this;
        this.currentData.clear(), e.forEach(function (e, r) {
          return t.currentData.set(r, e);
        });
      }, e.prototype.clear = function () {
        var e = new Map(this.currentData.entries());
        return this.currentData.clear(), e;
      }, e.prototype.has = function (e) {
        return this.currentData.has(e);
      }, e;
    }();

    t.UpdatingDataStore = n;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e12 = function e(t, r) {
        return (_e12 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e12(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) {
          for (var i in t = arguments[r]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = function (e) {
      function t(t, r) {
        var n = e.call(this, t) || this;
        return n.token = r, n;
      }

      return n(t, e), t.prototype.requestWrappedInApiResponse = function (t, r) {
        return o(this, void 0, void 0, function () {
          return a(this, function (n) {
            return [2, e.prototype.requestWrappedInApiResponse.call(this, i({}, t, {
              token: this.token
            }), r)];
          });
        });
      }, t.prototype.requestCollectionOfApiResponses = function (t, r) {
        return o(this, void 0, void 0, function () {
          return a(this, function (n) {
            return [2, e.prototype.requestCollectionOfApiResponses.call(this, i({}, t, {
              token: this.token
            }), r)];
          });
        });
      }, t.prototype.request = function (t, r) {
        return o(this, void 0, void 0, function () {
          return a(this, function (n) {
            return [2, e.prototype.request.call(this, i({}, t, {
              token: this.token
            }), r)];
          });
        });
      }, t.prototype.requestWithoutResponse = function (t) {
        return o(this, void 0, void 0, function () {
          return a(this, function (r) {
            return [2, e.prototype.requestWithoutResponse.call(this, i({}, t, {
              token: this.token
            }))];
          });
        });
      }, t.prototype.requestBlob = function (t) {
        return o(this, void 0, void 0, function () {
          return a(this, function (r) {
            return [2, e.prototype.requestBlob.call(this, i({}, t, {
              token: this.token
            }))];
          });
        });
      }, t.prototype.requestCollection = function (t, r) {
        return o(this, void 0, void 0, function () {
          return a(this, function (n) {
            return [2, e.prototype.requestCollection.call(this, i({}, t, {
              token: this.token
            }), r)];
          });
        });
      }, t;
    }(r(27).Requester);

    t.AuthenticatedRequester = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(123),
        a = r(124),
        s = r(125),
        u = function () {
      function e(e) {
        this.baseUrl = e, this.headerFactory = new o.HeaderFactory(), this.sequenceNumberParser = new s.SequenceNumberParser();
      }

      return e.prototype.requestWrappedInApiResponse = function (e, t) {
        return n(this, void 0, void 0, function () {
          var r, n, o, a, s;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.requestResponse(e)];

              case 1:
                return r = i.sent(), n = this.sequenceNumberParser.parseSequenceNumbers(r.text)[0], o = r.response, a = o.Content, s = t.deserialise(a), [2, {
                  Content: s,
                  Links: o.Links,
                  Relation: o.Relation,
                  SequenceNumber: n
                }];
            }
          });
        });
      }, e.prototype.requestCollectionOfApiResponses = function (e, t) {
        return n(this, void 0, void 0, function () {
          var r, n, o, a, s, u;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.requestResponse(e)];

              case 1:
                for (r = i.sent(), n = this.sequenceNumberParser.parseSequenceNumbers(r.text), o = 0; o < r.response.length; o++) {
                  a = r.response[o], s = n[o], a.SequenceNumber = s;
                }

                return u = r.response, [2, u.map(function (e) {
                  var r = e.Content;
                  return {
                    Content: t.deserialise(r),
                    Links: e.Links,
                    Relation: e.Relation,
                    SequenceNumber: e.SequenceNumber
                  };
                })];
            }
          });
        });
      }, e.prototype.request = function (e, t) {
        return n(this, void 0, void 0, function () {
          var r, n;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.requestResponse(e)];

              case 1:
                return r = i.sent(), n = r.response, [2, t.deserialise(n)];
            }
          });
        });
      }, e.prototype.requestCollection = function (e, t) {
        return n(this, void 0, void 0, function () {
          var r, n;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.requestResponse(e)];

              case 1:
                return r = i.sent(), n = r.response, [2, n.map(function (e) {
                  return t.deserialise(e);
                })];
            }
          });
        });
      }, e.prototype.requestWithoutResponse = function (e) {
        return n(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.requestResponse(e)];

              case 1:
                return t.sent(), [2];
            }
          });
        });
      }, e.prototype.requestBlob = function (e) {
        return n(this, void 0, void 0, function () {
          var t = this;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.requestRawResponse(e, function () {
                  return t.headerFactory.getHeadersForRawResponse(e.token, e.tradingAccountKey, e.productType);
                })];

              case 1:
                return [4, r.sent().blob()];

              case 2:
                return [2, r.sent()];
            }
          });
        });
      }, e.prototype.requestResponse = function (e) {
        return n(this, void 0, void 0, function () {
          var t,
              r,
              n,
              o,
              s = this;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.requestRawResponse(e, function () {
                  return s.headerFactory.getHeadersForJsonResponse(e.token, e.tradingAccountKey, e.productType);
                })];

              case 1:
                return [4, (t = i.sent()).text()];

              case 2:
                if (r = i.sent(), n = null != r && "" !== r ? JSON.parse(r) : null, !t.ok) throw new Error(r);
                return o = n, [2, new a.RequestResponse(o, r)];
            }
          });
        });
      }, e.prototype.requestRawResponse = function (e, t) {
        return n(this, void 0, void 0, function () {
          var r, n;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return r = new URL(this.baseUrl + "/" + e.path), e.query && (n = e.query, Object.keys(n).forEach(function (e) {
                  var t = n[e];
                  null !== t && void 0 !== t || (t = ""), r.searchParams.append(e, t);
                })), [4, fetch(r.toString(), {
                  method: e.method,
                  headers: t(),
                  body: null != e.body ? JSON.stringify(e.body) : null
                })];

              case 1:
                return [2, i.sent()];
            }
          });
        });
      }, e;
    }();

    t.Requester = u;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e13 = function e(t, r) {
        return (_e13 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e13(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(126),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.lightstreamerAuthenticationCredentialsRestDeserialiser = new o.LightstreamerAuthenticationCredentialsRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Host: e.Host,
          Port: e.Port,
          HttpsPort: e.HttpsPort,
          AdapterSet: e.AdapterSet,
          IsHttps: e.IsHttps,
          AuthenticationCredentials: this.lightstreamerAuthenticationCredentialsRestDeserialiser.deserialise(e.AuthenticationCredentials)
        };
      }, t;
    }(i.RestDeserialiser);

    t.LightstreamerConfigurationRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e14 = function e(t, r) {
        return (_e14 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e14(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Trades: e.Trades,
          Orders: e.Orders
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.MarketBookingStatusRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e15 = function e(t, r) {
        return (_e15 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e15(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(149),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.spreadBandRestDeserialiser = new o.SpreadBandRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          UnitType: e.UnitType,
          SpreadBands: e.SpreadBands.map(function (e) {
            return t.spreadBandRestDeserialiser.deserialise(e);
          })
        };
      }, t;
    }(i.RestDeserialiser);

    t.SpreadRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e16 = function e(t, r) {
        return (_e16 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e16(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.SourceRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      for (var r in e) {
        t.hasOwnProperty(r) || (t[r] = e[r]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(r(33)), n(r(60)), n(r(13));
    var i = r(61);
    t.SwanPublicClient = i.SwanPublicClient;
    var o = r(0);
    t.RestDeserialiser = o.RestDeserialiser;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(34);
    t.GuaranteedStopSetting = n.GuaranteedStopSetting;
    var i = r(35);
    t.SourceKey = i.SourceKey;
    var o = r(36);
    t.DistanceType = o.DistanceType;
    var a = r(37);
    t.ExchangeSubscriptionStatus = a.ExchangeSubscriptionStatus;
    var s = r(38);
    t.FinancingUnitType = s.FinancingUnitType;
    var u = r(39);
    t.LedgerProcessType = u.LedgerProcessType;
    var c = r(40);
    t.LifecycleType = c.LifecycleType;
    var d = r(41);
    t.LimitedRiskType = d.LimitedRiskType;
    var p = r(42);
    t.MarketListType = p.MarketListType;
    var l = r(43);
    t.MarketStatus = l.MarketStatus;
    var h = r(44);
    t.ProductType = h.ProductType;
    var y = r(45);
    t.SettlementType = y.SettlementType;
    var f = r(46);
    t.StatementPeriod = f.StatementPeriod;
    var g = r(47);
    t.SubscriptionFrequency = g.SubscriptionFrequency;
    var m = r(48);
    t.UnderlyingType = m.UnderlyingType;
    var P = r(49);
    t.SpreadUnitType = P.SpreadUnitType;
    var v = r(50);
    t.MarginUnitType = v.MarginUnitType;

    var _ = r(51);

    t.UnitType = _.UnitType;
    var O = r(52);
    t.TradeSubType = O.TradeSubType;
    var C = r(53);
    t.PositionStatus = C.PositionStatus;
    var b = r(54);
    t.TradeRejectionReason = b.TradeRejectionReason;
    var T = r(55);
    t.OrderRejectionReason = T.OrderRejectionReason;
    var D = r(56);
    t.OrderStatus = D.OrderStatus;
    var R = r(57);
    t.OrderType = R.OrderType;
    var I = r(58);
    t.TradeStatus = I.TradeStatus;
    var w = r(59);
    t.TradingInstructionDirection = w.TradingInstructionDirection;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Mandatory = 1] = "Mandatory", e[e.NotSupported = 2] = "NotSupported", e[e.Supported = 3] = "Supported";
    }(t.GuaranteedStopSetting || (t.GuaranteedStopSetting = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.User = 1] = "User", e[e.LinkedLimitOrder = 2] = "LinkedLimitOrder", e[e.LinkedStopOrder = 3] = "LinkedStopOrder", e[e.Order = 4] = "Order", e[e.AutoCloseout = 5] = "AutoCloseout", e[e.MarketExpiry = 6] = "MarketExpiry", e[e.PostTrade = 7] = "PostTrade", e[e.Rollover = 8] = "Rollover";
    }(t.SourceKey || (t.SourceKey = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Points = 0] = "Points", e[e.Percentage = 1] = "Percentage";
    }(t.DistanceType || (t.DistanceType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.NotSubscribed = 1] = "NotSubscribed", e[e.Subscribed = 2] = "Subscribed";
    }(t.ExchangeSubscriptionStatus || (t.ExchangeSubscriptionStatus = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.BasisPoint = 2] = "BasisPoint", e[e.Pip = 3] = "Pip";
    }(t.FinancingUnitType || (t.FinancingUnitType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Commission = 1] = "Commission", e[e.CommissionAdjustment = 2] = "CommissionAdjustment", e[e.Dividends = 3] = "Dividends", e[e.DividendsAdjustment = 4] = "DividendsAdjustment", e[e.Trade = 5] = "Trade", e[e.TradeAdjustment = 6] = "TradeAdjustment", e[e.Eft = 7] = "Eft", e[e.EftOverride = 8] = "EftOverride", e[e.Financing = 9] = "Financing", e[e.FinancingAdjustment = 10] = "FinancingAdjustment", e[e.GuaranteedOrderCharge = 11] = "GuaranteedOrderCharge", e[e.GuaranteedOrderChargeAdjustment = 12] = "GuaranteedOrderChargeAdjustment", e[e.CashBalanceInterest = 13] = "CashBalanceInterest", e[e.MarketingCharge = 14] = "MarketingCharge", e[e.Bacs = 15] = "Bacs", e[e.Cheque = 16] = "Cheque", e[e.TradingWriteOff = 17] = "TradingWriteOff", e[e.DebtWriteOff = 18] = "DebtWriteOff", e[e.GoodWillGesture = 19] = "GoodWillGesture", e[e.MiscellaneousAdjustment = 20] = "MiscellaneousAdjustment", e[e.FundsTransferCharge = 21] = "FundsTransferCharge", e[e.FxConversionCharge = 22] = "FxConversionCharge", e[e.EftCharge = 23] = "EftCharge", e[e.BalanceBroughtForward = 24] = "BalanceBroughtForward", e[e.InterAccountTransfers = 25] = "InterAccountTransfers", e[e.RollingCharge = 26] = "RollingCharge", e[e.FxSweep = 27] = "FxSweep", e[e.RolloverCharge = 28] = "RolloverCharge", e[e.MetaTraderTransfer = 29] = "MetaTraderTransfer", e[e.EWallet = 30] = "EWallet", e[e.ExchangePermissions = 31] = "ExchangePermissions", e[e.ExchangePermissionsAdjustment = 32] = "ExchangePermissionsAdjustment", e[e.CommissionOverride = 33] = "CommissionOverride", e[e.AdminCharge = 34] = "AdminCharge", e[e.AdminChargeAdjustment = 35] = "AdminChargeAdjustment", e[e.HandlingFee = 36] = "HandlingFee", e[e.HandlingFeeAdjustment = 37] = "HandlingFeeAdjustment", e[e.TradeSettlement = 38] = "TradeSettlement", e[e.TradeSettlementAdjustment = 39] = "TradeSettlementAdjustment", e[e.Rebate = 40] = "Rebate", e[e.RebateAdjustment = 41] = "RebateAdjustment";
    }(t.LedgerProcessType || (t.LedgerProcessType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Daily = 1] = "Daily", e[e.Monthly = 2] = "Monthly", e[e.Quarterly = 3] = "Quarterly", e[e.Nonexpiring = 4] = "Nonexpiring", e[e.Rolling = 5] = "Rolling";
    }(t.LifecycleType || (t.LifecycleType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Optional = 0] = "Optional", e[e.Always = 1] = "Always", e[e.Never = 2] = "Never";
    }(t.LimitedRiskType || (t.LimitedRiskType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.SystemWatchlist = 1] = "SystemWatchlist", e[e.MarketGroup = 2] = "MarketGroup", e[e.UserWatchlist = 65537] = "UserWatchlist";
    }(t.MarketListType || (t.MarketListType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.NotTradingYet = 3] = "NotTradingYet", e[e.FinishedTrading = 4] = "FinishedTrading", e[e.ExchangeBreak = 5] = "ExchangeBreak", e[e.ExchangeOnHoliday = 6] = "ExchangeOnHoliday", e[e.ExchangeClosed = 7] = "ExchangeClosed", e[e.Misconfigured = 8] = "Misconfigured";
    }(t.MarketStatus || (t.MarketStatus = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.SpreadBet = 1] = "SpreadBet", e[e.CFD = 2] = "CFD", e[e.SpotFX = 3] = "SpotFX";
    }(t.ProductType || (t.ProductType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Cash = 1] = "Cash", e[e.Futures = 2] = "Futures";
    }(t.SettlementType || (t.SettlementType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Daily = 1] = "Daily", e[e.Monthly = 2] = "Monthly";
    }(t.StatementPeriod || (t.StatementPeriod = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Daily = 1] = "Daily", e[e.Weekly = 2] = "Weekly", e[e.Monthly = 3] = "Monthly";
    }(t.SubscriptionFrequency || (t.SubscriptionFrequency = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.NotSet = 0] = "NotSet", e[e.Equity = 1] = "Equity", e[e.Commodity = 2] = "Commodity", e[e.Index = 3] = "Index", e[e.FX = 4] = "FX", e[e.InterestRate = 5] = "InterestRate", e[e.Funds = 6] = "Funds", e[e.Option = 7] = "Option";
    }(t.UnderlyingType || (t.UnderlyingType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Percentage = 1] = "Percentage", e[e.Point = 5] = "Point";
    }(t.SpreadUnitType || (t.SpreadUnitType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Percentage = 1] = "Percentage", e[e.Point = 5] = "Point";
    }(t.MarginUnitType || (t.MarginUnitType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Percentage = 1] = "Percentage", e[e.BasisPoint = 2] = "BasisPoint", e[e.Pip = 3] = "Pip", e[e.FixedRate = 4] = "FixedRate", e[e.Point = 5] = "Point";
    }(t.UnitType || (t.UnitType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.New = 1] = "New", e[e.Roll = 2] = "Roll", e[e.FxConversionOpen = 3] = "FxConversionOpen";
    }(t.TradeSubType || (t.TradeSubType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.TriggeredOrder = 3] = "TriggeredOrder";
    }(t.PositionStatus || (t.PositionStatus = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.None = 0] = "None", e[e.SystemError = 1] = "SystemError", e[e.MarginRequirementNotMet = 2] = "MarginRequirementNotMet", e[e.AutoCloseoutBreach = 3] = "AutoCloseoutBreach", e[e.PriceNotInHistory = 4] = "PriceNotInHistory", e[e.PriceNotInTradeableState = 5] = "PriceNotInTradeableState", e[e.TradingAccountNotFound = 6] = "TradingAccountNotFound", e[e.UnsupportedCurrency = 7] = "UnsupportedCurrency", e[e.ZeroQuantity = 8] = "ZeroQuantity", e[e.ClientAccountNotFound = 9] = "ClientAccountNotFound", e[e.QuoteNotFound = 10] = "QuoteNotFound", e[e.QuoteExpired = 11] = "QuoteExpired", e[e.QuoteNotApproved = 12] = "QuoteNotApproved", e[e.MarketNotFound = 13] = "MarketNotFound", e[e.OrderNotActive = 14] = "OrderNotActive", e[e.MinStakeLimitExceeded = 15] = "MinStakeLimitExceeded", e[e.MaxStakeLimitExceeded = 16] = "MaxStakeLimitExceeded", e[e.GuaranteedOrdersNotAllowed = 17] = "GuaranteedOrdersNotAllowed", e[e.MarketIsNotTrading = 18] = "MarketIsNotTrading", e[e.TradeQuantityExceeded = 19] = "TradeQuantityExceeded", e[e.IncorrectQuantity = 20] = "IncorrectQuantity", e[e.MultipleClosingOrdersNotAlowed = 21] = "MultipleClosingOrdersNotAlowed", e[e.SuspendedAccount = 22] = "SuspendedAccount", e[e.MarketAccountTypeMismatch = 23] = "MarketAccountTypeMismatch", e[e.GtdOrderDistanceBelowRequired = 24] = "GtdOrderDistanceBelowRequired", e[e.ContingentGtdOrderDistanceBelowRequired = 25] = "ContingentGtdOrderDistanceBelowRequired", e[e.PriceValueMismatch = 26] = "PriceValueMismatch", e[e.MarketUpLimit = 27] = "MarketUpLimit", e[e.MarketDownLimit = 28] = "MarketDownLimit", e[e.MarketShortLimit = 29] = "MarketShortLimit", e[e.MarketShortLimitOverclosing = 30] = "MarketShortLimitOverclosing", e[e.MandatoryStopOrder = 31] = "MandatoryStopOrder", e[e.PriceDistanceThresholdExceeded = 32] = "PriceDistanceThresholdExceeded", e[e.NonGtdOrderPlacedOnLimitedRiskAccount = 33] = "NonGtdOrderPlacedOnLimitedRiskAccount", e[e.NonGtdContingentOrderPlacedOnLimitedRiskAccount = 34] = "NonGtdContingentOrderPlacedOnLimitedRiskAccount", e[e.IncorrectJurisdiction = 35] = "IncorrectJurisdiction", e[e.GtdOrderPlacedOnNonLimitedRiskAccount = 36] = "GtdOrderPlacedOnNonLimitedRiskAccount", e[e.GtdContingentOrderPlacedOnNonLimitedRiskAccount = 37] = "GtdContingentOrderPlacedOnNonLimitedRiskAccount", e[e.TradeNotOpen = 38] = "TradeNotOpen", e[e.OpeningTradeOnClosingOnlyMarket = 39] = "OpeningTradeOnClosingOnlyMarket", e[e.OverclosingTradeOnClosingOnlyMarket = 40] = "OverclosingTradeOnClosingOnlyMarket", e[e.OpeningTradeOnClosingOnlyAccount = 41] = "OpeningTradeOnClosingOnlyAccount", e[e.OverclosingTradeOnClosingOnlyAccount = 42] = "OverclosingTradeOnClosingOnlyAccount", e[e.TradeBookingFrequencyLimitExceeded = 43] = "TradeBookingFrequencyLimitExceeded", e[e.Other = 44] = "Other", e[e.UnableToProcessTradeAtThisTime = 45] = "UnableToProcessTradeAtThisTime", e[e.TradeMatchStrategyNotSupported = 46] = "TradeMatchStrategyNotSupported", e[e.OrderApprovalNeverReturned = 47] = "OrderApprovalNeverReturned", e[e.MarginFactorOverrideIsNotValid = 48] = "MarginFactorOverrideIsNotValid", e[e.MarginFactorOverrideIsNotAllowed = 49] = "MarginFactorOverrideIsNotAllowed";
    }(t.TradeRejectionReason || (t.TradeRejectionReason = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.None = 0] = "None", e[e.SystemError = 1] = "SystemError", e[e.MarginRequirementNotMet = 2] = "MarginRequirementNotMet", e[e.AutoCloseoutBreach = 3] = "AutoCloseoutBreach", e[e.PriceNotInHistory = 4] = "PriceNotInHistory", e[e.PriceNotInTradeableState = 5] = "PriceNotInTradeableState", e[e.TradingAccountNotFound = 6] = "TradingAccountNotFound", e[e.UnsupportedCurrency = 7] = "UnsupportedCurrency", e[e.ZeroQuantity = 8] = "ZeroQuantity", e[e.ClientAccountNotFound = 9] = "ClientAccountNotFound", e[e.MarketNotFound = 10] = "MarketNotFound", e[e.OrderNotActive = 11] = "OrderNotActive", e[e.MinStakeLimitExceeded = 12] = "MinStakeLimitExceeded", e[e.MaxStakeLimitExceeded = 13] = "MaxStakeLimitExceeded", e[e.StandaloneOrderOnClosingOnlyMarket = 14] = "StandaloneOrderOnClosingOnlyMarket", e[e.StandaloneOrdersNotAllowed = 15] = "StandaloneOrdersNotAllowed", e[e.GoodTilDateOrdersNotAllowed = 16] = "GoodTilDateOrdersNotAllowed", e[e.GuaranteedOrdersNotAllowed = 17] = "GuaranteedOrdersNotAllowed", e[e.ContingentOrdersNotAllowed = 18] = "ContingentOrdersNotAllowed", e[e.MarketIsNotTrading = 19] = "MarketIsNotTrading", e[e.TradeQuantityExceeded = 20] = "TradeQuantityExceeded", e[e.IncorrectQuantity = 21] = "IncorrectQuantity", e[e.MultipleClosingOrdersNotAlowed = 22] = "MultipleClosingOrdersNotAlowed", e[e.StandaloneOrderOnClosingOnlyAccount = 23] = "StandaloneOrderOnClosingOnlyAccount", e[e.SuspendedAccount = 24] = "SuspendedAccount", e[e.MarketAccountTypeMismatch = 25] = "MarketAccountTypeMismatch", e[e.GtdOrderDistanceBelowRequired = 26] = "GtdOrderDistanceBelowRequired", e[e.ContingentGtdOrderDistanceBelowRequired = 27] = "ContingentGtdOrderDistanceBelowRequired", e[e.PriceValueMismatch = 28] = "PriceValueMismatch", e[e.MarketUpLimit = 29] = "MarketUpLimit", e[e.MarketDownLimit = 30] = "MarketDownLimit", e[e.MarketShortLimit = 31] = "MarketShortLimit", e[e.MarketShortLimitOverclosing = 32] = "MarketShortLimitOverclosing", e[e.StandaloneOrderOnLimitShortMarket = 33] = "StandaloneOrderOnLimitShortMarket", e[e.MandatoryStopOrder = 34] = "MandatoryStopOrder", e[e.PriceDistanceThresholdExceeded = 35] = "PriceDistanceThresholdExceeded", e[e.NonGtdOrderPlacedOnLimitedRiskAccount = 36] = "NonGtdOrderPlacedOnLimitedRiskAccount", e[e.NonGtdContingentOrderPlacedOnLimitedRiskAccount = 37] = "NonGtdContingentOrderPlacedOnLimitedRiskAccount", e[e.IncorrectJurisdiction = 38] = "IncorrectJurisdiction", e[e.GtdOrderPlacedOnNonLimitedRiskAccount = 39] = "GtdOrderPlacedOnNonLimitedRiskAccount", e[e.GtdContingentOrderPlacedOnNonLimitedRiskAccount = 40] = "GtdContingentOrderPlacedOnNonLimitedRiskAccount", e[e.Other = 41] = "Other", e[e.OrderDistanceBelowRequired = 42] = "OrderDistanceBelowRequired", e[e.MarginFactorOverrideIsNotValid = 43] = "MarginFactorOverrideIsNotValid", e[e.MarginFactorOverrideIsNotAllowed = 44] = "MarginFactorOverrideIsNotAllowed";
    }(t.OrderRejectionReason || (t.OrderRejectionReason = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Active = 0] = "Active", e[e.Filled = 1] = "Filled", e[e.Cancelled = 2] = "Cancelled", e[e.Expired = 3] = "Expired", e[e.AwaitingApproval = 4] = "AwaitingApproval";
    }(t.OrderStatus || (t.OrderStatus = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Stop = 0] = "Stop", e[e.Limit = 1] = "Limit";
    }(t.OrderType || (t.OrderType = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e[e.TriggeredStopOrder = 2] = "TriggeredStopOrder", e[e.TriggeredLimitOrder = 3] = "TriggeredLimitOrder", e[e.Cancelled = 4] = "Cancelled";
    }(t.TradeStatus || (t.TradeStatus = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Buy = 1] = "Buy", e[e.Sell = 2] = "Sell";
    }(t.TradingInstructionDirection || (t.TradingInstructionDirection = {}));
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      var t = e;
      return void 0 !== t.Key && void 0 !== t.Amount && void 0 !== t.PostingType && void 0 !== t.PostingDate;
    }

    function i(e) {
      var t = e;
      return n(t) && void 0 !== t.TradeKey;
    }

    function o(e) {
      var t = e;
      return n(t) && void 0 !== t.TradeMatchKey;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isPosting = n, t.isTradePosting = i, t.isTradeMatchPosting = o, t.isConvertedTradePosting = function (e) {
      var t = e;
      return i(t) && void 0 !== t.FxRate;
    }, t.isConvertedTradeMatchPosting = function (e) {
      var t = e;
      return o(t) && void 0 !== t.FxRate;
    };
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(62),
        a = r(63),
        s = r(65),
        u = r(68),
        c = r(69),
        d = r(72),
        p = r(73),
        l = r(75),
        h = r(77),
        y = r(78),
        f = r(80),
        g = r(82),
        m = r(84),
        P = r(85),
        v = r(88),
        _ = r(89),
        O = r(90),
        C = r(91),
        b = r(92),
        T = r(93),
        D = r(94),
        R = r(95),
        I = r(96),
        w = r(97),
        S = r(98),
        N = r(99),
        k = r(100),
        M = r(101),
        K = r(102),
        A = r(103),
        j = r(104),
        q = r(105),
        V = r(106),
        E = r(122),
        x = r(26),
        L = r(28),
        F = r(127),
        W = r(129),
        B = r(134),
        G = r(136),
        U = r(138),
        Q = r(139),
        H = r(141),
        J = r(151),
        z = r(153),
        X = r(27),
        Y = r(154),
        Z = r(155),
        $ = r(156),
        ee = r(157),
        te = r(158),
        re = r(159),
        ne = r(160),
        ie = r(161),
        oe = r(162),
        ae = r(163),
        se = r(164),
        ue = r(165),
        ce = r(166),
        de = r(173),
        pe = r(174),
        le = r(175),
        he = r(176),
        ye = r(177),
        fe = r(178),
        ge = r(179),
        me = "Must call createPushConnection() before streaming",
        Pe = function () {
      function e(e, t) {
        e.startsWith("//") ? this.url = window.location.protocol + e : this.url = e, this.requester = t ? new x.AuthenticatedRequester(this.url, t) : new Y.ThrowingRequester();
      }

      return e.prototype.connectToPush = function (e, t, r) {
        this.pushConnection = new V.PushConnection(e, t, r), this.pushConnection.connect();
      }, e.prototype.authenticate = function (e, t, r, o, a) {
        return n(this, void 0, void 0, function () {
          var n, s, u;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return n = new X.Requester(this.url), s = {
                  AccountOperatorKey: r,
                  Username: e,
                  Password: t
                }, [4, n.requestWrappedInApiResponse({
                  path: "api/Authentication",
                  method: "POST",
                  body: s,
                  token: ""
                }, new W.AuthenticationResponseRestDeserialiser())];

              case 1:
                return u = i.sent(), this.connectToPush(u.Content.Authentication.LightstreamerConfiguration, o, a), this.requester = new x.AuthenticatedRequester(this.url, u.Content.Authentication.Token), [2, u];
            }
          });
        });
      }, e.prototype.deauthenticate = function () {
        return n(this, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return this.pushConnection && (this.pushConnection.disconnect(), this.pushConnection = void 0), [4, this.requester.requestWithoutResponse({
                  path: "api/Authentication",
                  method: "DELETE"
                })];

              case 1:
                return e.sent(), [2];
            }
          });
        });
      }, e.prototype.getCandles = function (e) {
        return n(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.requester.requestCollection({
                  method: "GET",
                  path: "api/Candles",
                  query: z.convertGetCandlesRequestToQuery(e)
                }, new U.CandleRestDeserialiser())];

              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.getIncompleteCandle = function (e, t) {
        return n(this, void 0, void 0, function () {
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.requester.requestWrappedInApiResponse({
                  method: "GET",
                  path: "api/Candles/Incomplete",
                  query: {
                    marketKey: e,
                    period: t.toString()
                  }
                }, new U.CandleRestDeserialiser())];

              case 1:
                return [2, r.sent()];
            }
          });
        });
      }, e.prototype.getLightstreamerConfiguration = function () {
        return n(this, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.requester.requestWrappedInApiResponse({
                  method: "GET",
                  path: "api/Configuration/Lightstreamer"
                }, new L.LightstreamerConfigurationRestDeserialiser())];

              case 1:
                return [2, e.sent()];
            }
          });
        });
      }, e.prototype.streamCandles = function (e, t, r) {
        if (!this.pushConnection) throw new Error(me);
        var n = new A.CandleFieldNameProvider(),
            i = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.C",
          dataAdapter: "PublicApiV1Candle",
          subscriptionMode: "MERGE",
          requestPushSnapshot: !0
        }, n, e);
        return this.pushConnection.createMergePushStream(i, new D.CandleDeserialiser(n), new u.CandleDataCombiner(), t, void 0 !== r ? r : function () {}, function (e) {
          return e.Key;
        }, void 0, new m.CandleDataTransformer());
      }, e.prototype.getMarket = function (e) {
        return n(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.requester.requestWrappedInApiResponse({
                  method: "GET",
                  path: "api/Markets/" + e
                }, new H.MarketRestDeserialiser())];

              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.getMarketLists = function (e) {
        return n(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.requester.requestCollectionOfApiResponses({
                  method: "GET",
                  path: "api/MarketLists",
                  productType: e
                }, new Q.MarketListRestDeserialiser())];

              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.getMarketListMarkets = function (e) {
        return n(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.requester.requestCollectionOfApiResponses({
                  path: "api/MarketLists/" + e + "/Markets",
                  method: "GET"
                }, new J.MarketSummaryRestDeserialiser())];

              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.getTrades = function (e) {
        return n(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.requester.requestCollectionOfApiResponses({
                  path: "api/Trades",
                  method: "GET",
                  tradingAccountKey: e
                }, new G.TradeRestDeserialiser())];

              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.getPositions = function (e) {
        return n(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.requester.requestCollectionOfApiResponses({
                  path: "api/Positions",
                  method: "GET",
                  tradingAccountKey: e
                }, new ne.PositionRestDeserialiser())];

              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.getOrdersByTrade = function (e, t) {
        return n(this, void 0, void 0, function () {
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.requester.requestCollectionOfApiResponses({
                  path: "api/Trades/" + e + "/Orders",
                  method: "GET",
                  tradingAccountKey: t
                }, new B.OrderRestDeserialiser())];

              case 1:
                return [2, r.sent()];
            }
          });
        });
      }, e.prototype.getAccount = function () {
        return n(this, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.requester.requestWrappedInApiResponse({
                  path: "api/Account",
                  method: "GET"
                }, new F.AccountRestDeserialiser())];

              case 1:
                return [2, e.sent()];
            }
          });
        });
      }, e.prototype.getClientAccountResources = function () {
        return n(this, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.requester.requestWrappedInApiResponse({
                  path: "api/Account/Resources",
                  method: "GET"
                }, new Z.AccountResourcesRestDeserialiser())];

              case 1:
                return [2, e.sent()];
            }
          });
        });
      }, e.prototype.getTradingAccountResources = function (e) {
        return n(this, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.requester.requestWrappedInApiResponse({
                  path: "api/TradingAccount/" + e + "/Resources",
                  method: "GET"
                }, new ue.TradingAccountResourcesRestDeserialiser())];

              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.getTradeHistory = function (e, t, r, o, a, s, u) {
        return n(this, void 0, void 0, function () {
          var n;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return n = {
                  from: t.toISOString(),
                  to: r.toISOString()
                }, void 0 !== o && (n.marketName = o), void 0 !== a && (n.tradeDirection = a.toString()), void 0 !== s && (n.valueDateFrom = s.toISOString()), void 0 !== u && (n.valueDateTo = u.toISOString()), [4, this.requester.requestWrappedInApiResponse({
                  path: "api/Trades/History",
                  method: "GET",
                  tradingAccountKey: e,
                  query: n
                }, new ce.HistoricalTradeResponseRestDeserialiser())];

              case 1:
                return [2, i.sent()];
            }
          });
        });
      }, e.prototype.searchTrades = function (e, t, r, o, a, s, u, c) {
        return n(this, void 0, void 0, function () {
          var n;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return n = {
                  from: t.toISOString(),
                  to: r.toISOString()
                }, void 0 !== o && (n.marketName = o), void 0 !== a && (n.direction = a.toString()), void 0 !== s && (n.valueDateFrom = s.toISOString()), void 0 !== u && (n.valueDateTo = u.toISOString()), void 0 !== c && (n.subType = c.toString()), [4, this.requester.requestWrappedInApiResponse({
                  path: "api/Trades/Search",
                  method: "GET",
                  tradingAccountKey: e,
                  query: n
                }, new ge.TradeSearchResponseRestDeserialiser())];

              case 1:
                return [2, i.sent()];
            }
          });
        });
      }, e.prototype.getStatements = function (e, t, r, o) {
        return n(this, void 0, void 0, function () {
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.requester.requestCollectionOfApiResponses({
                  path: "api/Statements",
                  method: "GET",
                  tradingAccountKey: e,
                  query: {
                    from: t.toISOString(),
                    to: r.toISOString(),
                    period: o.toString()
                  }
                }, new de.StatementRestDeserialiser())];

              case 1:
                return [2, n.sent()];
            }
          });
        });
      }, e.prototype.getExchangeRate = function (e, t) {
        return n(this, void 0, void 0, function () {
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.requester.requestWrappedInApiResponse({
                  path: "api/ExchangeRates?fromCurrency=" + e + "&toCurrency=" + t,
                  method: "GET"
                }, new fe.ExchangeRateRestDeserialiser())];

              case 1:
                return [2, r.sent()];
            }
          });
        });
      }, e.prototype.getStatement = function (e, t) {
        return n(this, void 0, void 0, function () {
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.requester.requestBlob({
                  path: "api/Statements/" + t,
                  method: "GET",
                  tradingAccountKey: e
                })];

              case 1:
                return [2, r.sent()];
            }
          });
        });
      }, e.prototype.streamMarketListMarkets = function (e, t, r) {
        var n = this;
        if (!this.pushConnection) throw new Error(me);
        var i = new j.MarketSummaryFieldNameProvider(),
            o = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.MSs",
          dataAdapter: "PublicApiV1MarketSummarys",
          subscriptionMode: "MERGE",
          requestPushSnapshot: !1
        }, i, e);
        return this.pushConnection.createMergeWithStructurePushStream(o, new R.MarketSummaryDeserialiser(i), new c.MarketSummaryDataCombiner(), t, void 0 !== r ? r : function () {}, function (e) {
          return e.Key;
        }, function () {
          return n.getMarketListMarkets(e);
        });
      }, e.prototype.streamTradeBookingResponses = function (e, t, r) {
        if (!this.pushConnection) throw new Error(me);
        var n = new M.TradeBookingResponseFieldNameProvider(),
            i = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.TBRs",
          dataAdapter: "PublicApiV1TradeBookingResponses",
          subscriptionMode: "DISTINCT",
          requestPushSnapshot: !1
        }, n, e);
        return this.pushConnection.createDistinctPushStream(i, new b.TradeBookingResponseDeserialiser(n), new f.TradeBookingResponseDataTransformer(), t, void 0 !== r ? r : function () {});
      }, e.prototype.streamTrades = function (e, t, r) {
        var n = this;
        if (!this.pushConnection) throw new Error(me);
        var i = new K.TradeFieldNameProvider(),
            o = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.Ts",
          dataAdapter: "PublicApiV1Trades",
          subscriptionMode: "COMMAND",
          requestPushSnapshot: !1
        }, i, e);
        return this.pushConnection.createCommandPushStream(o, new T.TradeDeserialiser(i), new s.TradeDataCombiner(), new g.TradeDataTransformer(), t, void 0 !== r ? r : function () {}, function (e) {
          return e.InstructionKey.Key;
        }, function () {
          return n.getTrades(e);
        });
      }, e.prototype.streamOrdersByTrade = function (e, t, r, n) {
        var i = this;
        if (!this.pushConnection) throw new Error(me);
        var o = new k.OrderFieldNameProvider(),
            s = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.OBT",
          dataAdapter: "PublicApiV1OrdersByTrade",
          subscriptionMode: "COMMAND",
          requestPushSnapshot: !1
        }, o, e);
        return this.pushConnection.createCommandPushStream(s, new O.OrderDeserialiser(o), new a.OrderDataCombiner(), new h.OrderDataTransformer(), r, void 0 !== n ? n : function () {}, function (e) {
          return e.InstructionKey.Key;
        }, function () {
          return i.getOrdersByTrade(e, t);
        });
      }, e.prototype.streamOrderBookingResponses = function (e, t, r) {
        if (!this.pushConnection) throw new Error(me);
        var n = new w.OrderBookingResponseFieldNameProvider(),
            i = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.OBRs",
          dataAdapter: "PublicApiV1OrderBookingResponses",
          subscriptionMode: "DISTINCT",
          requestPushSnapshot: !1
        }, n, e);
        return this.pushConnection.createDistinctPushStream(i, new v.OrderBookingResponseDeserialiser(n), new p.OrderBookingResponseDataTransformer(), t, void 0 !== r ? r : function () {});
      }, e.prototype.streamOrderCancellingResponses = function (e, t, r) {
        if (!this.pushConnection) throw new Error(me);
        var n = new S.OrderCancellingResponseFieldNameProvider(),
            i = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.OCRs",
          dataAdapter: "PublicApiV1OrderCancellingResponses",
          subscriptionMode: "DISTINCT",
          requestPushSnapshot: !1
        }, n, e);
        return this.pushConnection.createDistinctPushStream(i, new _.OrderCancellingResponseDeserialiser(n), new l.OrderCancellingResponseDataTransformer(), t, void 0 !== r ? r : function () {});
      }, e.prototype.streamOrderEditingResponses = function (e, t, r) {
        if (!this.pushConnection) throw new Error(me);
        var n = new N.OrderEditingResponseFieldNameProvider(),
            i = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.OERs",
          dataAdapter: "PublicApiV1OrderEditingResponses",
          subscriptionMode: "DISTINCT",
          requestPushSnapshot: !1
        }, n, e);
        return this.pushConnection.createDistinctPushStream(i, new C.OrderEditingResponseDeserialiser(n), new y.OrderEditingResponseDataTransformer(), t, void 0 !== r ? r : function () {});
      }, e.prototype.streamClientAccountResources = function (e, t, r) {
        var n = this;
        if (!this.pushConnection) throw new Error(me);
        var i = new I.AccountResourcesFieldNameProvider(),
            a = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.ARs",
          dataAdapter: "PublicApiV1AccountResources",
          subscriptionMode: "COMMAND",
          requestPushSnapshot: !1
        }, i, e);
        return this.pushConnection.createCommandPushStream(a, new P.AccountResourcesDeserialiser(i), new o.AccountResourcesDataCombiner(), new d.AccountResourcesDataTransformer(), t, void 0 !== r ? r : function () {}, function (e) {
          return e.Key;
        }, function () {
          return n.getClientAccountResources();
        });
      }, e.prototype.streamPositions = function (e, t, r) {
        var n = this;
        if (!this.pushConnection) throw new Error(me);
        var i = new $.PositionFieldNameProvider(),
            o = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.Ps",
          dataAdapter: "PublicApiV1Positions",
          subscriptionMode: "COMMAND",
          requestPushSnapshot: !1
        }, i, e);
        return this.pushConnection.createCommandPushStream(o, new ee.PositionDeserialiser(i), new te.PositionDataCombiner(), new re.PositionDataTransformer(), t, void 0 !== r ? r : function () {}, function (e) {
          return e.PositionKey.Key;
        }, function () {
          return n.getPositions(e);
        });
      }, e.prototype.streamTradingAccountResources = function (e, t, r) {
        var n = this;
        if (!this.pushConnection) throw new Error(me);
        var i = new ie.TradingAccountResourcesFieldNameProvider(),
            o = new q.LightstreamerPushSubscriptionFactory({
          groupName: "PAPI.V1.TARs",
          dataAdapter: "PublicApiV1TradingAccountResources",
          subscriptionMode: "COMMAND",
          requestPushSnapshot: !1
        }, i, e);
        return this.pushConnection.createCommandPushStream(o, new oe.TradingAccountResourcesDeserialiser(i), new ae.TradingAccountResourcesDataCombiner(), new se.TradingAccountResourcesDataTransformer(), t, void 0 !== r ? r : function () {}, function (e) {
          return e.Key;
        }, function () {
          return n.getTradingAccountResources(e);
        });
      }, e.prototype.streamExchangeRates = function (e, t, r, n) {
        return this.stream("PAPI.V1.ER", "PublicApiV1ExchangeRate", E.LightstreamerMode.Command, pe.ExchangeRateFieldNameProvider, le.ExchangeRateDeserialiser, he.ExchangeRateDataCombiner, ye.ExchangeRateDataTransformer, e, function (e) {
          return e.Key;
        }, t, void 0, r, n);
      }, e.prototype.request = function (e, t) {
        return n(this, void 0, void 0, function () {
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.requester.request(e, t)];

              case 1:
                return [2, r.sent()];
            }
          });
        });
      }, e.prototype.requestWrappedInApiResponse = function (e, t) {
        return n(this, void 0, void 0, function () {
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.requester.requestWrappedInApiResponse(e, t)];

              case 1:
                return [2, r.sent()];
            }
          });
        });
      }, e.prototype.stream = function (e, t, r, n, i, o, a, s, u, c, d, p, l) {
        if (!this.pushConnection) throw new Error(me);
        var h,
            y = {
          groupName: e,
          dataAdapter: t,
          subscriptionMode: r,
          requestPushSnapshot: !1,
          updateMaxFrequency: l
        },
            f = new n(),
            g = new q.LightstreamerPushSubscriptionFactory(y, f, s);

        switch (r) {
          case E.LightstreamerMode.Command:
            h = this.pushConnection.createCommandPushStream(g, new i(f), new o(), new a(), c, void 0 !== p ? p : function () {}, u, d);
            break;

          default:
            throw new Error("No implementation defined for subscription mode " + r);
        }

        return h;
      }, e;
    }();

    t.SwanPublicClient = Pe;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e17 = function e(t, r) {
        return (_e17 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e17(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Key: this.combineProperty(t.Key, e.Key),
          CashBalance: this.combineProperty(t.CashBalance, e.CashBalance),
          OpenPnl: this.combineProperty(t.OpenPnl, e.OpenPnl),
          NetEquity: this.combineProperty(t.NetEquity, e.NetEquity),
          MarginRequirement: this.combineProperty(t.MarginRequirement, e.MarginRequirement),
          AvailableBalance: this.combineProperty(t.AvailableBalance, e.AvailableBalance),
          Credit: this.combineProperty(t.Credit, e.Credit),
          WaivedDeposit: this.combineProperty(t.WaivedDeposit, e.WaivedDeposit),
          TotalPosition: this.combineProperty(t.TotalPosition, e.TotalPosition),
          NetOpenPositionLimit: this.combineProperty(t.NetOpenPositionLimit, e.NetOpenPositionLimit),
          NetOpenPosition: this.combineProperty(t.NetOpenPosition, e.NetOpenPosition)
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.AccountResourcesDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e18 = function e(t, r) {
        return (_e18 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e18(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(7),
        o = r(9),
        a = r(3),
        s = r(10),
        u = r(64),
        c = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataCombiner = new s.InstructionKeyDataCombiner(), t.orderGroupingDataCombiner = new u.OrderGroupingDataCombiner(), t.instructionKeyDataTransformer = new i.InstructionKeyDataTransformer(), t.orderGroupingDataTransformer = new o.OrderGroupingDataTransformer(), t;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        var r = this;
        return {
          InstructionKey: this.combineSubObject(t.InstructionKey, e.InstructionKey, function (e, t) {
            return r.instructionKeyDataCombiner.combine(e, t);
          }),
          AccountKey: this.combineProperty(t.AccountKey, e.AccountKey),
          TradingAccountKey: this.combineProperty(t.TradingAccountKey, e.TradingAccountKey),
          MarketKey: this.combineProperty(t.MarketKey, e.MarketKey),
          MarketName: this.combineProperty(t.MarketName, e.MarketName),
          OrderType: this.combineProperty(t.OrderType, e.OrderType),
          Quantity: this.combineProperty(t.Quantity, e.Quantity),
          TriggerPrice: this.combineProperty(t.TriggerPrice, e.TriggerPrice),
          Status: this.combineProperty(t.Status, e.Status),
          LinkedTradeInstructionKey: this.combineOptionalSubObject(t.LinkedTradeInstructionKey, e.LinkedTradeInstructionKey, function (e, t) {
            return r.instructionKeyDataCombiner.combine(e, t);
          }, function (e) {
            return r.instructionKeyDataTransformer.transform(e);
          }),
          CurrencyId: this.combineProperty(t.CurrencyId, e.CurrencyId),
          Level: this.combineProperty(t.Level, e.Level),
          ContingentStopDistance: this.combineProperty(t.ContingentStopDistance, e.ContingentStopDistance),
          ContingentLimitDistance: this.combineProperty(t.ContingentLimitDistance, e.ContingentLimitDistance),
          TrailingStep: this.combineProperty(t.TrailingStep, e.TrailingStep),
          TriggeringTime: this.combineProperty(t.TriggeringTime, e.TriggeringTime),
          IsGuaranteed: this.combineProperty(t.IsGuaranteed, e.IsGuaranteed),
          ContingentIsGuaranteedStop: this.combineProperty(t.ContingentIsGuaranteedStop, e.ContingentIsGuaranteedStop),
          Reference: this.combineProperty(t.Reference, e.Reference),
          ExpiryDateTime: this.combineProperty(t.ExpiryDateTime, e.ExpiryDateTime),
          BookingDate: this.combineProperty(t.BookingDate, e.BookingDate),
          Grouping: this.combineOptionalSubObject(t.Grouping, e.Grouping, function (e, t) {
            return r.orderGroupingDataCombiner.combine(e, t);
          }, function (e) {
            return r.orderGroupingDataTransformer.transform(e);
          }),
          ClientRequestId: this.combineProperty(t.ClientRequestId, e.ClientRequestId),
          ClientRequestReference: this.combineProperty(t.ClientRequestReference, e.ClientRequestReference)
        };
      }, t;
    }(a.PushDataCombiner);

    t.OrderDataCombiner = c;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e19 = function e(t, r) {
        return (_e19 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e19(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Orders: this.combineProperty(t.Orders, e.Orders)
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.OrderGroupingDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e20 = function e(t, r) {
        return (_e20 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e20(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(3),
        o = r(66),
        a = r(10),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataCombiner = new a.InstructionKeyDataCombiner(), t.considerationDataCombiner = new o.ConsiderationDataCombiner(), t;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        var r = this;
        return {
          InstructionKey: this.combineSubObject(t.InstructionKey, e.InstructionKey, function (e, t) {
            return r.instructionKeyDataCombiner.combine(e, t);
          }),
          AccountKey: this.combineProperty(t.AccountKey, e.AccountKey),
          TradingAccountKey: this.combineProperty(t.TradingAccountKey, e.TradingAccountKey),
          MarketKey: this.combineProperty(t.MarketKey, e.MarketKey),
          MarketName: this.combineProperty(t.MarketName, e.MarketName),
          Quantity: this.combineProperty(t.Quantity, e.Quantity),
          BookingTime: this.combineProperty(t.BookingTime, e.BookingTime),
          CurrentPrice: this.combineProperty(t.CurrentPrice, e.CurrentPrice),
          OpenPnl: this.combineProperty(t.OpenPnl, e.OpenPnl),
          CurrencyId: this.combineProperty(t.CurrencyId, e.CurrencyId),
          MarginRequirement: this.combineProperty(t.MarginRequirement, e.MarginRequirement),
          BookingPrice: this.combineProperty(t.BookingPrice, e.BookingPrice),
          HasLinkedOrders: this.combineProperty(t.HasLinkedOrders, e.HasLinkedOrders),
          Reference: this.combineProperty(t.Reference, e.Reference),
          Status: this.combineProperty(t.Status, e.Status),
          ClientRequestId: this.combineProperty(t.ClientRequestId, e.ClientRequestId),
          ClientRequestReference: this.combineProperty(t.ClientRequestReference, e.ClientRequestReference),
          ValueDate: this.combineProperty(t.ValueDate, e.ValueDate),
          Consideration: this.combineSubObject(t.Consideration, e.Consideration, function (e, t) {
            return r.considerationDataCombiner.combine(e, t);
          }),
          SubType: this.combineProperty(t.SubType, e.SubType)
        };
      }, t;
    }(i.PushDataCombiner);

    t.TradeDataCombiner = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e21 = function e(t, r) {
        return (_e21 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e21(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(16),
        o = r(3),
        a = r(67),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.considerationValueDataCombiner = new a.ConsiderationValueDataCombiner(), t.considerationValueDataTransformer = new i.ConsiderationValueDataTransformer(), t;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        var r = this;
        return {
          BaseConsideration: this.combineOptionalSubObject(t.BaseConsideration, e.BaseConsideration, function (e, t) {
            return r.considerationValueDataCombiner.combine(e, t);
          }, function (e) {
            return r.considerationValueDataTransformer.transform(e);
          }),
          DeliveryConsideration: this.combineOptionalSubObject(t.DeliveryConsideration, e.DeliveryConsideration, function (e, t) {
            return r.considerationValueDataCombiner.combine(e, t);
          }, function (e) {
            return r.considerationValueDataTransformer.transform(e);
          })
        };
      }, t;
    }(o.PushDataCombiner);

    t.ConsiderationDataCombiner = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e22 = function e(t, r) {
        return (_e22 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e22(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Value: this.combineProperty(t.Value, e.Value),
          CurrencyId: this.combineProperty(t.CurrencyId, e.CurrencyId)
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.ConsiderationValueDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e23 = function e(t, r) {
        return (_e23 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e23(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Time: this.combineProperty(t.Time, e.Time),
          Key: this.combineProperty(t.Key, e.Key),
          Open: this.combineProperty(t.Open, e.Open),
          Close: this.combineProperty(t.Close, e.Close),
          High: this.combineProperty(t.High, e.High),
          Low: this.combineProperty(t.Low, e.Low)
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.CandleDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e24 = function e(t, r) {
        return (_e24 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e24(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(3),
        o = r(70),
        a = r(71),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.marketPriceSummaryDataCombiner = new a.MarketPriceSummaryDataCombiner(), t.marketBookingStatusDataCombiner = new o.MarketBookingStatusDataCombiner(), t;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        var r = this;
        return {
          Key: this.combineProperty(t.Key, e.Key),
          Name: this.combineProperty(t.Name, e.Name),
          DecimalPlaces: this.combineProperty(t.DecimalPlaces, e.DecimalPlaces),
          BetPer: this.combineProperty(t.BetPer, e.BetPer),
          TradeViaApi: this.combineProperty(t.TradeViaApi, e.TradeViaApi),
          ExchangeKey: this.combineProperty(t.ExchangeKey, e.ExchangeKey),
          MarketType: this.combineProperty(t.MarketType, e.MarketType),
          SettlementType: this.combineProperty(t.SettlementType, e.SettlementType),
          Price: this.combineSubObject(t.Price, e.Price, function (e, t) {
            return r.marketPriceSummaryDataCombiner.combine(e, t);
          }),
          Accepts: this.combineSubObject(t.Accepts, e.Accepts, function (e, t) {
            return r.marketBookingStatusDataCombiner.combine(e, t);
          })
        };
      }, t;
    }(i.PushDataCombiner);

    t.MarketSummaryDataCombiner = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e25 = function e(t, r) {
        return (_e25 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e25(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Trades: this.combineProperty(t.Trades, e.Trades),
          Orders: this.combineProperty(t.Orders, e.Orders)
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.MarketBookingStatusDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e26 = function e(t, r) {
        return (_e26 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e26(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Key: this.combineProperty(t.Key, e.Key),
          Bid: this.combineProperty(t.Bid, e.Bid),
          Ask: this.combineProperty(t.Ask, e.Ask),
          ChangeOnDay: this.combineProperty(t.ChangeOnDay, e.ChangeOnDay),
          ChangeOnDayPercentage: this.combineProperty(t.ChangeOnDayPercentage, e.ChangeOnDayPercentage),
          High: this.combineProperty(t.High, e.High),
          Low: this.combineProperty(t.Low, e.Low),
          Spread: e.Spread
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.MarketPriceSummaryDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e27 = function e(t, r) {
        return (_e27 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e27(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Key) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CashBalance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OpenPnl) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.NetEquity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarginRequirement) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.AvailableBalance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Credit) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.WaivedDeposit) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TotalPosition) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.NetOpenPositionLimit) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.NetOpenPosition)) return {
          Key: e.Key.property,
          CashBalance: e.CashBalance.property,
          OpenPnl: e.OpenPnl.property,
          NetEquity: e.NetEquity.property,
          MarginRequirement: e.MarginRequirement.property,
          AvailableBalance: e.AvailableBalance.property,
          Credit: e.Credit.property,
          WaivedDeposit: e.WaivedDeposit.property,
          TotalPosition: e.TotalPosition.property,
          NetOpenPositionLimit: e.NetOpenPositionLimit.property,
          NetOpenPosition: e.NetOpenPosition.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.AccountResourcesDataTransformer = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e28 = function e(t, r) {
        return (_e28 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e28(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(74),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.openedOrderDataTransformer = new a.OpenedOrderDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RequestKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketName) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RejectionReason) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OpenedOrder)) return {
          RequestKey: e.RequestKey.property,
          MarketKey: e.MarketKey.property,
          MarketName: e.MarketName.property,
          RejectionReason: e.RejectionReason.property,
          OpenedOrder: void 0 !== e.OpenedOrder.property ? this.openedOrderDataTransformer.transform(e.OpenedOrder.property) : void 0
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.OrderBookingResponseDataTransformer = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e29 = function e(t, r) {
        return (_e29 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e29(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(7),
        s = r(9),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataTransformer = new a.InstructionKeyDataTransformer(), t.orderGroupingDataTransformer = new s.OrderGroupingDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.InstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OrderType) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Quantity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TriggerPrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Status) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.LinkedTradeInstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Level) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentStopDistance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentLimitDistance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TrailingStep) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TriggeringTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.IsGuaranteed) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentIsGuaranteedStop) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Reference) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ExpiryDateTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Distance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Grouping) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestReference)) return {
          InstructionKey: this.instructionKeyDataTransformer.transform(e.InstructionKey.property),
          OrderType: e.OrderType.property,
          Quantity: e.Quantity.property,
          TriggerPrice: e.TriggerPrice.property,
          Status: e.Status.property,
          LinkedTradeInstructionKey: void 0 !== e.LinkedTradeInstructionKey.property ? this.instructionKeyDataTransformer.transform(e.LinkedTradeInstructionKey.property) : void 0,
          CurrencyId: e.CurrencyId.property,
          Level: e.Level.property,
          ContingentStopDistance: e.ContingentStopDistance.property,
          ContingentLimitDistance: e.ContingentLimitDistance.property,
          TrailingStep: e.TrailingStep.property,
          TriggeringTime: e.TriggeringTime.property,
          IsGuaranteed: e.IsGuaranteed.property,
          ContingentIsGuaranteedStop: e.ContingentIsGuaranteedStop.property,
          Reference: e.Reference.property,
          ExpiryDateTime: e.ExpiryDateTime.property,
          Distance: e.Distance.property,
          Grouping: void 0 !== e.Grouping.property ? this.orderGroupingDataTransformer.transform(e.Grouping.property) : void 0,
          ClientRequestId: e.ClientRequestId.property,
          ClientRequestReference: e.ClientRequestReference.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.OpenedOrderDataTransformer = u;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e30 = function e(t, r) {
        return (_e30 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e30(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(76),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.cancelledOrderDataTransformer = new a.CancelledOrderDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RequestKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketName) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RejectionReason) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CancelledOrder)) return {
          RequestKey: e.RequestKey.property,
          MarketKey: e.MarketKey.property,
          MarketName: e.MarketName.property,
          RejectionReason: e.RejectionReason.property,
          CancelledOrder: void 0 !== e.CancelledOrder.property ? this.cancelledOrderDataTransformer.transform(e.CancelledOrder.property) : void 0
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.OrderCancellingResponseDataTransformer = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e31 = function e(t, r) {
        return (_e31 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e31(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(7),
        s = r(9),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataTransformer = new a.InstructionKeyDataTransformer(), t.orderGroupingDataTransformer = new s.OrderGroupingDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.InstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OrderType) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Quantity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TriggerPrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Status) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.LinkedTradeInstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Level) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentStopDistance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentLimitDistance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TrailingStep) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TriggeringTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.IsGuaranteed) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentIsGuaranteedStop) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Reference) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ExpiryDateTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Distance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Grouping) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestReference)) return {
          InstructionKey: this.instructionKeyDataTransformer.transform(e.InstructionKey.property),
          OrderType: e.OrderType.property,
          Quantity: e.Quantity.property,
          TriggerPrice: e.TriggerPrice.property,
          Status: e.Status.property,
          LinkedTradeInstructionKey: void 0 !== e.LinkedTradeInstructionKey.property ? this.instructionKeyDataTransformer.transform(e.LinkedTradeInstructionKey.property) : void 0,
          CurrencyId: e.CurrencyId.property,
          Level: e.Level.property,
          ContingentStopDistance: e.ContingentStopDistance.property,
          ContingentLimitDistance: e.ContingentLimitDistance.property,
          TrailingStep: e.TrailingStep.property,
          TriggeringTime: e.TriggeringTime.property,
          IsGuaranteed: e.IsGuaranteed.property,
          ContingentIsGuaranteedStop: e.ContingentIsGuaranteedStop.property,
          Reference: e.Reference.property,
          ExpiryDateTime: e.ExpiryDateTime.property,
          Distance: e.Distance.property,
          Grouping: void 0 !== e.Grouping.property ? this.orderGroupingDataTransformer.transform(e.Grouping.property) : void 0,
          ClientRequestId: e.ClientRequestId.property,
          ClientRequestReference: e.ClientRequestReference.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.CancelledOrderDataTransformer = u;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e32 = function e(t, r) {
        return (_e32 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e32(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(7),
        s = r(9),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataTransformer = new a.InstructionKeyDataTransformer(), t.orderGroupingDataTransformer = new s.OrderGroupingDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.InstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.AccountKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TradingAccountKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketName) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OrderType) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Quantity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TriggerPrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Status) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.LinkedTradeInstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Level) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentStopDistance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentLimitDistance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TrailingStep) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TriggeringTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.IsGuaranteed) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentIsGuaranteedStop) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Reference) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ExpiryDateTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.BookingDate) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Grouping) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestReference)) return {
          InstructionKey: this.instructionKeyDataTransformer.transform(e.InstructionKey.property),
          AccountKey: e.AccountKey.property,
          TradingAccountKey: e.TradingAccountKey.property,
          MarketKey: e.MarketKey.property,
          MarketName: e.MarketName.property,
          OrderType: e.OrderType.property,
          Quantity: e.Quantity.property,
          TriggerPrice: e.TriggerPrice.property,
          Status: e.Status.property,
          LinkedTradeInstructionKey: void 0 !== e.LinkedTradeInstructionKey.property ? this.instructionKeyDataTransformer.transform(e.LinkedTradeInstructionKey.property) : void 0,
          CurrencyId: e.CurrencyId.property,
          Level: e.Level.property,
          ContingentStopDistance: e.ContingentStopDistance.property,
          ContingentLimitDistance: e.ContingentLimitDistance.property,
          TrailingStep: e.TrailingStep.property,
          TriggeringTime: e.TriggeringTime.property,
          IsGuaranteed: e.IsGuaranteed.property,
          ContingentIsGuaranteedStop: e.ContingentIsGuaranteedStop.property,
          Reference: e.Reference.property,
          ExpiryDateTime: e.ExpiryDateTime.property,
          BookingDate: e.BookingDate.property,
          Grouping: void 0 !== e.Grouping.property ? this.orderGroupingDataTransformer.transform(e.Grouping.property) : void 0,
          ClientRequestId: e.ClientRequestId.property,
          ClientRequestReference: e.ClientRequestReference.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.OrderDataTransformer = u;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e33 = function e(t, r) {
        return (_e33 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e33(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(79),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.editedOrderDataTransformer = new a.EditedOrderDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RequestKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketName) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RejectionReason) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.EditedOrder)) return {
          RequestKey: e.RequestKey.property,
          MarketKey: e.MarketKey.property,
          MarketName: e.MarketName.property,
          RejectionReason: e.RejectionReason.property,
          EditedOrder: void 0 !== e.EditedOrder.property ? this.editedOrderDataTransformer.transform(e.EditedOrder.property) : void 0
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.OrderEditingResponseDataTransformer = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e34 = function e(t, r) {
        return (_e34 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e34(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(7),
        s = r(9),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataTransformer = new a.InstructionKeyDataTransformer(), t.orderGroupingDataTransformer = new s.OrderGroupingDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.InstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OrderType) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Quantity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TriggerPrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Status) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.LinkedTradeInstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Level) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentStopDistance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentLimitDistance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TrailingStep) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TriggeringTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.IsGuaranteed) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ContingentIsGuaranteedStop) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Reference) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ExpiryDateTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Distance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Grouping) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestReference)) return {
          InstructionKey: this.instructionKeyDataTransformer.transform(e.InstructionKey.property),
          OrderType: e.OrderType.property,
          Quantity: e.Quantity.property,
          TriggerPrice: e.TriggerPrice.property,
          Status: e.Status.property,
          LinkedTradeInstructionKey: void 0 !== e.LinkedTradeInstructionKey.property ? this.instructionKeyDataTransformer.transform(e.LinkedTradeInstructionKey.property) : void 0,
          CurrencyId: e.CurrencyId.property,
          Level: e.Level.property,
          ContingentStopDistance: e.ContingentStopDistance.property,
          ContingentLimitDistance: e.ContingentLimitDistance.property,
          TrailingStep: e.TrailingStep.property,
          TriggeringTime: e.TriggeringTime.property,
          IsGuaranteed: e.IsGuaranteed.property,
          ContingentIsGuaranteedStop: e.ContingentIsGuaranteedStop.property,
          Reference: e.Reference.property,
          ExpiryDateTime: e.ExpiryDateTime.property,
          Distance: e.Distance.property,
          Grouping: void 0 !== e.Grouping.property ? this.orderGroupingDataTransformer.transform(e.Grouping.property) : void 0,
          ClientRequestId: e.ClientRequestId.property,
          ClientRequestReference: e.ClientRequestReference.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.EditedOrderDataTransformer = u;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e35 = function e(t, r) {
        return (_e35 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e35(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(81),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.openedTradeDataTransformer = new a.OpenedTradeDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RequestKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketName) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RejectionReason) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OpenedTrade) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OpenedOrders) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClosedTrades) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RequestedQuantity)) return {
          RequestKey: e.RequestKey.property,
          MarketKey: e.MarketKey.property,
          MarketName: e.MarketName.property,
          RejectionReason: e.RejectionReason.property,
          OpenedTrade: void 0 !== e.OpenedTrade.property ? this.openedTradeDataTransformer.transform(e.OpenedTrade.property) : void 0,
          OpenedOrders: e.OpenedOrders.property,
          ClosedTrades: e.ClosedTrades.property,
          RequestedQuantity: e.RequestedQuantity.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.TradeBookingResponseDataTransformer = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e36 = function e(t, r) {
        return (_e36 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e36(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(7),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataTransformer = new a.InstructionKeyDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.InstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Quantity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.NewOpenQuantity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TradePrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.RequestedPrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Reference) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketExpiry) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Slippage) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestReference)) return {
          InstructionKey: this.instructionKeyDataTransformer.transform(e.InstructionKey.property),
          Quantity: e.Quantity.property,
          NewOpenQuantity: e.NewOpenQuantity.property,
          CurrencyId: e.CurrencyId.property,
          TradePrice: e.TradePrice.property,
          RequestedPrice: e.RequestedPrice.property,
          Reference: e.Reference.property,
          MarketExpiry: e.MarketExpiry.property,
          Slippage: e.Slippage.property,
          ClientRequestId: e.ClientRequestId.property,
          ClientRequestReference: e.ClientRequestReference.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.OpenedTradeDataTransformer = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e37 = function e(t, r) {
        return (_e37 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e37(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(83),
        s = r(7),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataTransformer = new s.InstructionKeyDataTransformer(), t.considerationDataTransformer = new a.ConsiderationDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.InstructionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.AccountKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TradingAccountKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketName) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Quantity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.BookingTime) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrentPrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OpenPnl) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarginRequirement) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.BookingPrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.HasLinkedOrders) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Reference) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Status) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ClientRequestReference) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ValueDate) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Consideration) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.SubType)) return {
          InstructionKey: this.instructionKeyDataTransformer.transform(e.InstructionKey.property),
          AccountKey: e.AccountKey.property,
          TradingAccountKey: e.TradingAccountKey.property,
          MarketKey: e.MarketKey.property,
          MarketName: e.MarketName.property,
          Quantity: e.Quantity.property,
          BookingTime: e.BookingTime.property,
          CurrentPrice: e.CurrentPrice.property,
          OpenPnl: e.OpenPnl.property,
          CurrencyId: e.CurrencyId.property,
          MarginRequirement: e.MarginRequirement.property,
          BookingPrice: e.BookingPrice.property,
          HasLinkedOrders: e.HasLinkedOrders.property,
          Reference: e.Reference.property,
          Status: e.Status.property,
          ClientRequestId: e.ClientRequestId.property,
          ClientRequestReference: e.ClientRequestReference.property,
          ValueDate: e.ValueDate.property,
          Consideration: this.considerationDataTransformer.transform(e.Consideration.property),
          SubType: e.SubType.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.TradeDataTransformer = u;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e38 = function e(t, r) {
        return (_e38 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e38(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(16),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.considerationValueDataTransformer = new a.ConsiderationValueDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.BaseConsideration) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.DeliveryConsideration)) return {
          BaseConsideration: void 0 !== e.BaseConsideration.property ? this.considerationValueDataTransformer.transform(e.BaseConsideration.property) : void 0,
          DeliveryConsideration: void 0 !== e.DeliveryConsideration.property ? this.considerationValueDataTransformer.transform(e.DeliveryConsideration.property) : void 0
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.ConsiderationDataTransformer = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e39 = function e(t, r) {
        return (_e39 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e39(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Time) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Key) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Open) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Close) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.High) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Low)) return {
          Time: e.Time.property,
          Key: e.Key.property,
          Open: e.Open.property,
          Close: e.Close.property,
          High: e.High.property,
          Low: e.Low.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.CandleDataTransformer = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e40 = function e(t, r) {
        return (_e40 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e40(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = {
          Key: this.getWrappedValue(this.fieldNameProvider.accountKey, e, this.getString),
          CashBalance: this.getWrappedValue(this.fieldNameProvider.cashBalance, e, this.getNumber),
          OpenPnl: this.getWrappedValue(this.fieldNameProvider.openPnl, e, this.getNumber),
          NetEquity: this.getWrappedValue(this.fieldNameProvider.netEquity, e, this.getNumber),
          MarginRequirement: this.getWrappedValue(this.fieldNameProvider.marginRequirement, e, this.getNumber),
          AvailableBalance: this.getWrappedValue(this.fieldNameProvider.availableBalance, e, this.getNumber),
          Credit: this.getWrappedValue(this.fieldNameProvider.credit, e, this.getNumber),
          WaivedDeposit: this.getWrappedValue(this.fieldNameProvider.waivedDeposit, e, this.getNumber),
          TotalPosition: this.getWrappedValue(this.fieldNameProvider.totalPosition, e, this.getNumber),
          NetOpenPositionLimit: this.getWrappedValue(this.fieldNameProvider.netOpenPositionLimit, e, this.getOptionalNumber),
          NetOpenPosition: this.getWrappedValue(this.fieldNameProvider.netOpenPosition, e, this.getNumber)
        };
        return this.getDeserialisationResult(t, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.AccountResourcesDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      return function (e, t, r, n) {
        this.result = e, this.sequenceNumber = t, this.key = r, this.input = n;
      };
    }();

    t.DeserialisationResult = n;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e41 = function e(t, r) {
        return (_e41 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e41(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t;
    }(r(15).IntermediateProperty);

    t.UnchangedIntermediateProperty = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e42 = function e(t, r) {
        return (_e42 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e42(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this.isValueUndefined(this.fieldNameProvider.openedOrderInstructionKeyKey, e),
            r = this.isValueUndefined(this.fieldNameProvider.openedOrderLinkedTradeInstructionKeyKey, e),
            n = this.isValueUndefined(this.fieldNameProvider.openedOrderGroupingOrders, e),
            i = this.isValueUndefined(this.fieldNameProvider.openedOrderOrderType, e),
            o = this.isValueUndefined(this.fieldNameProvider.openedOrderQuantity, e),
            a = this.isValueUndefined(this.fieldNameProvider.openedOrderTriggerPrice, e),
            s = this.isValueUndefined(this.fieldNameProvider.openedOrderStatus, e),
            u = this.isValueUndefined(this.fieldNameProvider.openedOrderCurrencyId, e),
            c = this.isValueUndefined(this.fieldNameProvider.openedOrderLevel, e),
            d = this.isValueUndefined(this.fieldNameProvider.openedOrderContingentStopDistance, e),
            p = this.isValueUndefined(this.fieldNameProvider.openedOrderContingentLimitDistance, e),
            l = this.isValueUndefined(this.fieldNameProvider.openedOrderTrailingStep, e),
            h = this.isValueUndefined(this.fieldNameProvider.openedOrderTriggeringTime, e),
            y = this.isValueUndefined(this.fieldNameProvider.openedOrderIsGuaranteed, e),
            f = this.isValueUndefined(this.fieldNameProvider.openedOrderContingentIsGuaranteedStop, e),
            g = this.isValueUndefined(this.fieldNameProvider.openedOrderReference, e),
            m = this.isValueUndefined(this.fieldNameProvider.openedOrderExpiryDateTime, e),
            P = this.isValueUndefined(this.fieldNameProvider.openedOrderDistance, e),
            v = this.isValueUndefined(this.fieldNameProvider.openedOrderClientRequestId, e),
            _ = this.isValueUndefined(this.fieldNameProvider.openedOrderClientRequestReference, e),
            O = t && r && n && i && o && a && s && u && c && d && p && l && h && y && f && g && m && P && v && _,
            C = {
          Key: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderInstructionKeyKey, e, this.getString)
        },
            b = r ? void 0 : {
          Key: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderLinkedTradeInstructionKeyKey, e, this.getString)
        },
            T = n ? void 0 : {
          Orders: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderGroupingOrders, e, this.getArray)
        },
            D = O ? void 0 : {
          InstructionKey: this.getWrappedChangedValueFromObject(C),
          OrderType: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderOrderType, e, this.getOrderType),
          Quantity: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderQuantity, e, this.getNumber),
          TriggerPrice: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderTriggerPrice, e, this.getNumber),
          Status: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderStatus, e, this.getOrderStatus),
          LinkedTradeInstructionKey: this.getWrappedChangedValueFromObject(b),
          CurrencyId: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderCurrencyId, e, this.getInt),
          Level: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderLevel, e, this.getNumber),
          ContingentStopDistance: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderContingentStopDistance, e, this.getOptionalNumber),
          ContingentLimitDistance: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderContingentLimitDistance, e, this.getOptionalNumber),
          TrailingStep: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderTrailingStep, e, this.getOptionalNumber),
          TriggeringTime: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderTriggeringTime, e, this.getOptionalDate),
          IsGuaranteed: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderIsGuaranteed, e, this.getBoolean),
          ContingentIsGuaranteedStop: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderContingentIsGuaranteedStop, e, this.getBoolean),
          Reference: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderReference, e, this.getString),
          ExpiryDateTime: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderExpiryDateTime, e, this.getOptionalDate),
          Distance: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderDistance, e, this.getNumber),
          Grouping: this.getWrappedChangedValueFromObject(T),
          ClientRequestId: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderClientRequestId, e, this.getString),
          ClientRequestReference: this.getWrappedChangedValue(this.fieldNameProvider.openedOrderClientRequestReference, e, this.getString)
        },
            R = {
          RequestKey: this.getWrappedChangedValue(this.fieldNameProvider.requestKey, e, this.getString),
          MarketKey: this.getWrappedChangedValue(this.fieldNameProvider.marketKey, e, this.getString),
          MarketName: this.getWrappedChangedValue(this.fieldNameProvider.marketName, e, this.getString),
          RejectionReason: this.getWrappedChangedValue(this.fieldNameProvider.rejectionReason, e, this.getOrderRejectionReason),
          OpenedOrder: this.getWrappedChangedValueFromObject(D)
        };

        return this.getDeserialisationResult(R, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.OrderBookingResponseDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e43 = function e(t, r) {
        return (_e43 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e43(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this.isValueUndefined(this.fieldNameProvider.cancelledOrderInstructionKeyKey, e),
            r = this.isValueUndefined(this.fieldNameProvider.cancelledOrderLinkedTradeInstructionKeyKey, e),
            n = this.isValueUndefined(this.fieldNameProvider.cancelledOrderGroupingOrders, e),
            i = this.isValueUndefined(this.fieldNameProvider.cancelledOrderOrderType, e),
            o = this.isValueUndefined(this.fieldNameProvider.cancelledOrderQuantity, e),
            a = this.isValueUndefined(this.fieldNameProvider.cancelledOrderTriggerPrice, e),
            s = this.isValueUndefined(this.fieldNameProvider.cancelledOrderStatus, e),
            u = this.isValueUndefined(this.fieldNameProvider.cancelledOrderCurrencyId, e),
            c = this.isValueUndefined(this.fieldNameProvider.cancelledOrderLevel, e),
            d = this.isValueUndefined(this.fieldNameProvider.cancelledOrderContingentStopDistance, e),
            p = this.isValueUndefined(this.fieldNameProvider.cancelledOrderContingentLimitDistance, e),
            l = this.isValueUndefined(this.fieldNameProvider.cancelledOrderTrailingStep, e),
            h = this.isValueUndefined(this.fieldNameProvider.cancelledOrderTriggeringTime, e),
            y = this.isValueUndefined(this.fieldNameProvider.cancelledOrderIsGuaranteed, e),
            f = this.isValueUndefined(this.fieldNameProvider.cancelledOrderContingentIsGuaranteedStop, e),
            g = this.isValueUndefined(this.fieldNameProvider.cancelledOrderReference, e),
            m = this.isValueUndefined(this.fieldNameProvider.cancelledOrderExpiryDateTime, e),
            P = this.isValueUndefined(this.fieldNameProvider.cancelledOrderDistance, e),
            v = this.isValueUndefined(this.fieldNameProvider.cancelledOrderClientRequestId, e),
            _ = this.isValueUndefined(this.fieldNameProvider.cancelledOrderClientRequestReference, e),
            O = t && r && n && i && o && a && s && u && c && d && p && l && h && y && f && g && m && P && v && _,
            C = {
          Key: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderInstructionKeyKey, e, this.getString)
        },
            b = r ? void 0 : {
          Key: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderLinkedTradeInstructionKeyKey, e, this.getString)
        },
            T = n ? void 0 : {
          Orders: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderGroupingOrders, e, this.getArray)
        },
            D = O ? void 0 : {
          InstructionKey: this.getWrappedChangedValueFromObject(C),
          OrderType: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderOrderType, e, this.getOrderType),
          Quantity: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderQuantity, e, this.getNumber),
          TriggerPrice: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderTriggerPrice, e, this.getNumber),
          Status: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderStatus, e, this.getOrderStatus),
          LinkedTradeInstructionKey: this.getWrappedChangedValueFromObject(b),
          CurrencyId: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderCurrencyId, e, this.getInt),
          Level: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderLevel, e, this.getNumber),
          ContingentStopDistance: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderContingentStopDistance, e, this.getOptionalNumber),
          ContingentLimitDistance: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderContingentLimitDistance, e, this.getOptionalNumber),
          TrailingStep: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderTrailingStep, e, this.getOptionalNumber),
          TriggeringTime: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderTriggeringTime, e, this.getOptionalDate),
          IsGuaranteed: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderIsGuaranteed, e, this.getBoolean),
          ContingentIsGuaranteedStop: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderContingentIsGuaranteedStop, e, this.getBoolean),
          Reference: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderReference, e, this.getString),
          ExpiryDateTime: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderExpiryDateTime, e, this.getOptionalDate),
          Distance: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderDistance, e, this.getNumber),
          Grouping: this.getWrappedChangedValueFromObject(T),
          ClientRequestId: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderClientRequestId, e, this.getString),
          ClientRequestReference: this.getWrappedChangedValue(this.fieldNameProvider.cancelledOrderClientRequestReference, e, this.getString)
        },
            R = {
          RequestKey: this.getWrappedChangedValue(this.fieldNameProvider.requestKey, e, this.getString),
          MarketKey: this.getWrappedChangedValue(this.fieldNameProvider.marketKey, e, this.getString),
          MarketName: this.getWrappedChangedValue(this.fieldNameProvider.marketName, e, this.getString),
          RejectionReason: this.getWrappedChangedValue(this.fieldNameProvider.rejectionReason, e, this.getOrderRejectionReason),
          CancelledOrder: this.getWrappedChangedValueFromObject(D)
        };

        return this.getDeserialisationResult(R, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.OrderCancellingResponseDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e44 = function e(t, r) {
        return (_e44 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e44(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this.isValueUndefined(this.fieldNameProvider.linkedTradeInstructionKeyKey, e),
            r = this.isValueUndefined(this.fieldNameProvider.groupingOrders, e),
            n = {
          Key: this.getWrappedValue(this.fieldNameProvider.instructionKeyKey, e, this.getString)
        },
            i = t ? void 0 : {
          Key: this.getWrappedValue(this.fieldNameProvider.linkedTradeInstructionKeyKey, e, this.getString)
        },
            o = r ? void 0 : {
          Orders: this.getWrappedValue(this.fieldNameProvider.groupingOrders, e, this.getArray)
        },
            a = {
          InstructionKey: this.getWrappedInIntermediateProperty(n),
          AccountKey: this.getWrappedValue(this.fieldNameProvider.accountKey, e, this.getString),
          TradingAccountKey: this.getWrappedValue(this.fieldNameProvider.tradingAccountKey, e, this.getString),
          MarketKey: this.getWrappedValue(this.fieldNameProvider.marketKey, e, this.getString),
          MarketName: this.getWrappedValue(this.fieldNameProvider.marketName, e, this.getString),
          OrderType: this.getWrappedValue(this.fieldNameProvider.orderType, e, this.getOrderType),
          Quantity: this.getWrappedValue(this.fieldNameProvider.quantity, e, this.getNumber),
          TriggerPrice: this.getWrappedValue(this.fieldNameProvider.triggerPrice, e, this.getNumber),
          Status: this.getWrappedValue(this.fieldNameProvider.status, e, this.getOrderStatus),
          LinkedTradeInstructionKey: this.getWrappedInIntermediateProperty(i),
          CurrencyId: this.getWrappedValue(this.fieldNameProvider.currencyId, e, this.getInt),
          Level: this.getWrappedValue(this.fieldNameProvider.level, e, this.getNumber),
          ContingentStopDistance: this.getWrappedValue(this.fieldNameProvider.contingentStopDistance, e, this.getOptionalNumber),
          ContingentLimitDistance: this.getWrappedValue(this.fieldNameProvider.contingentLimitDistance, e, this.getOptionalNumber),
          TrailingStep: this.getWrappedValue(this.fieldNameProvider.trailingStep, e, this.getOptionalNumber),
          TriggeringTime: this.getWrappedValue(this.fieldNameProvider.triggeringTime, e, this.getOptionalDate),
          IsGuaranteed: this.getWrappedValue(this.fieldNameProvider.isGuaranteed, e, this.getBoolean),
          ContingentIsGuaranteedStop: this.getWrappedValue(this.fieldNameProvider.contingentIsGuaranteedStop, e, this.getBoolean),
          Reference: this.getWrappedValue(this.fieldNameProvider.reference, e, this.getString),
          ExpiryDateTime: this.getWrappedValue(this.fieldNameProvider.expiryDateTime, e, this.getOptionalDate),
          BookingDate: this.getWrappedValue(this.fieldNameProvider.bookingDate, e, this.getDate),
          Grouping: this.getWrappedInIntermediateProperty(o),
          ClientRequestId: this.getWrappedValue(this.fieldNameProvider.clientRequestId, e, this.getString),
          ClientRequestReference: this.getWrappedValue(this.fieldNameProvider.clientRequestReference, e, this.getString)
        };
        return this.getDeserialisationResult(a, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.OrderDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e45 = function e(t, r) {
        return (_e45 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e45(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this.isValueUndefined(this.fieldNameProvider.editedOrderInstructionKeyKey, e),
            r = this.isValueUndefined(this.fieldNameProvider.editedOrderLinkedTradeInstructionKeyKey, e),
            n = this.isValueUndefined(this.fieldNameProvider.editedOrderGroupingOrders, e),
            i = this.isValueUndefined(this.fieldNameProvider.editedOrderOrderType, e),
            o = this.isValueUndefined(this.fieldNameProvider.editedOrderQuantity, e),
            a = this.isValueUndefined(this.fieldNameProvider.editedOrderTriggerPrice, e),
            s = this.isValueUndefined(this.fieldNameProvider.editedOrderStatus, e),
            u = this.isValueUndefined(this.fieldNameProvider.editedOrderCurrencyId, e),
            c = this.isValueUndefined(this.fieldNameProvider.editedOrderLevel, e),
            d = this.isValueUndefined(this.fieldNameProvider.editedOrderContingentStopDistance, e),
            p = this.isValueUndefined(this.fieldNameProvider.editedOrderContingentLimitDistance, e),
            l = this.isValueUndefined(this.fieldNameProvider.editedOrderTrailingStep, e),
            h = this.isValueUndefined(this.fieldNameProvider.editedOrderTriggeringTime, e),
            y = this.isValueUndefined(this.fieldNameProvider.editedOrderIsGuaranteed, e),
            f = this.isValueUndefined(this.fieldNameProvider.editedOrderContingentIsGuaranteedStop, e),
            g = this.isValueUndefined(this.fieldNameProvider.editedOrderReference, e),
            m = this.isValueUndefined(this.fieldNameProvider.editedOrderExpiryDateTime, e),
            P = this.isValueUndefined(this.fieldNameProvider.editedOrderDistance, e),
            v = this.isValueUndefined(this.fieldNameProvider.editedOrderClientRequestId, e),
            _ = this.isValueUndefined(this.fieldNameProvider.editedOrderClientRequestReference, e),
            O = t && r && n && i && o && a && s && u && c && d && p && l && h && y && f && g && m && P && v && _,
            C = {
          Key: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderInstructionKeyKey, e, this.getString)
        },
            b = r ? void 0 : {
          Key: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderLinkedTradeInstructionKeyKey, e, this.getString)
        },
            T = n ? void 0 : {
          Orders: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderGroupingOrders, e, this.getArray)
        },
            D = O ? void 0 : {
          InstructionKey: this.getWrappedChangedValueFromObject(C),
          OrderType: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderOrderType, e, this.getOrderType),
          Quantity: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderQuantity, e, this.getNumber),
          TriggerPrice: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderTriggerPrice, e, this.getNumber),
          Status: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderStatus, e, this.getOrderStatus),
          LinkedTradeInstructionKey: this.getWrappedChangedValueFromObject(b),
          CurrencyId: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderCurrencyId, e, this.getInt),
          Level: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderLevel, e, this.getNumber),
          ContingentStopDistance: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderContingentStopDistance, e, this.getOptionalNumber),
          ContingentLimitDistance: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderContingentLimitDistance, e, this.getOptionalNumber),
          TrailingStep: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderTrailingStep, e, this.getOptionalNumber),
          TriggeringTime: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderTriggeringTime, e, this.getOptionalDate),
          IsGuaranteed: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderIsGuaranteed, e, this.getBoolean),
          ContingentIsGuaranteedStop: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderContingentIsGuaranteedStop, e, this.getBoolean),
          Reference: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderReference, e, this.getString),
          ExpiryDateTime: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderExpiryDateTime, e, this.getOptionalDate),
          Distance: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderDistance, e, this.getNumber),
          Grouping: this.getWrappedChangedValueFromObject(T),
          ClientRequestId: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderClientRequestId, e, this.getString),
          ClientRequestReference: this.getWrappedChangedValue(this.fieldNameProvider.editedOrderClientRequestReference, e, this.getString)
        },
            R = {
          RequestKey: this.getWrappedChangedValue(this.fieldNameProvider.requestKey, e, this.getString),
          MarketKey: this.getWrappedChangedValue(this.fieldNameProvider.marketKey, e, this.getString),
          MarketName: this.getWrappedChangedValue(this.fieldNameProvider.marketName, e, this.getString),
          RejectionReason: this.getWrappedChangedValue(this.fieldNameProvider.rejectionReason, e, this.getOrderRejectionReason),
          EditedOrder: this.getWrappedChangedValueFromObject(D)
        };

        return this.getDeserialisationResult(R, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.OrderEditingResponseDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e46 = function e(t, r) {
        return (_e46 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e46(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this.isValueUndefined(this.fieldNameProvider.openedTradeInstructionKeyKey, e),
            r = this.isValueUndefined(this.fieldNameProvider.openedTradeQuantity, e),
            n = this.isValueUndefined(this.fieldNameProvider.openedTradeNewOpenQuantity, e),
            i = this.isValueUndefined(this.fieldNameProvider.openedTradeCurrencyId, e),
            o = this.isValueUndefined(this.fieldNameProvider.openedTradeTradePrice, e),
            a = this.isValueUndefined(this.fieldNameProvider.openedTradeRequestedPrice, e),
            s = this.isValueUndefined(this.fieldNameProvider.openedTradeReference, e),
            u = this.isValueUndefined(this.fieldNameProvider.openedTradeMarketExpiry, e),
            c = this.isValueUndefined(this.fieldNameProvider.openedTradeSlippage, e),
            d = this.isValueUndefined(this.fieldNameProvider.openedTradeClientRequestId, e),
            p = this.isValueUndefined(this.fieldNameProvider.openedTradeClientRequestReference, e),
            l = t && r && n && i && o && a && s && u && c && d && p,
            h = {
          Key: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeInstructionKeyKey, e, this.getString)
        },
            y = l ? void 0 : {
          InstructionKey: this.getWrappedChangedValueFromObject(h),
          Quantity: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeQuantity, e, this.getNumber),
          NewOpenQuantity: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeNewOpenQuantity, e, this.getNumber),
          CurrencyId: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeCurrencyId, e, this.getInt),
          TradePrice: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeTradePrice, e, this.getNumber),
          RequestedPrice: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeRequestedPrice, e, this.getNumber),
          Reference: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeReference, e, this.getString),
          MarketExpiry: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeMarketExpiry, e, this.getOptionalDate),
          Slippage: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeSlippage, e, this.getOptionalNumber),
          ClientRequestId: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeClientRequestId, e, this.getString),
          ClientRequestReference: this.getWrappedChangedValue(this.fieldNameProvider.openedTradeClientRequestReference, e, this.getString)
        },
            f = {
          RequestKey: this.getWrappedChangedValue(this.fieldNameProvider.requestKey, e, this.getString),
          MarketKey: this.getWrappedChangedValue(this.fieldNameProvider.marketKey, e, this.getString),
          MarketName: this.getWrappedChangedValue(this.fieldNameProvider.marketName, e, this.getString),
          RejectionReason: this.getWrappedChangedValue(this.fieldNameProvider.rejectionReason, e, this.getTradeRejectionReason),
          OpenedTrade: this.getWrappedChangedValueFromObject(y),
          OpenedOrders: this.getWrappedChangedValue(this.fieldNameProvider.openedOrders, e, this.getArray),
          ClosedTrades: this.getWrappedChangedValue(this.fieldNameProvider.closedTrades, e, this.getArray),
          RequestedQuantity: this.getWrappedChangedValue(this.fieldNameProvider.requestedQuantity, e, this.getOptionalNumber)
        };
        return this.getDeserialisationResult(f, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.TradeBookingResponseDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e47 = function e(t, r) {
        return (_e47 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e47(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this.isValueUndefined(this.fieldNameProvider.considerationBaseConsiderationValue, e),
            r = this.isValueUndefined(this.fieldNameProvider.considerationBaseConsiderationCurrencyId, e),
            n = t && r,
            i = this.isValueUndefined(this.fieldNameProvider.considerationDeliveryConsiderationValue, e),
            o = this.isValueUndefined(this.fieldNameProvider.considerationDeliveryConsiderationCurrencyId, e),
            a = i && o,
            s = {
          Key: this.getWrappedValue(this.fieldNameProvider.instructionKeyKey, e, this.getString)
        },
            u = n ? void 0 : {
          Value: this.getWrappedValue(this.fieldNameProvider.considerationBaseConsiderationValue, e, this.getNumber),
          CurrencyId: this.getWrappedValue(this.fieldNameProvider.considerationBaseConsiderationCurrencyId, e, this.getInt)
        },
            c = a ? void 0 : {
          Value: this.getWrappedValue(this.fieldNameProvider.considerationDeliveryConsiderationValue, e, this.getNumber),
          CurrencyId: this.getWrappedValue(this.fieldNameProvider.considerationDeliveryConsiderationCurrencyId, e, this.getInt)
        },
            d = {
          BaseConsideration: this.getWrappedInIntermediateProperty(u),
          DeliveryConsideration: this.getWrappedInIntermediateProperty(c)
        },
            p = {
          InstructionKey: this.getWrappedInIntermediateProperty(s),
          AccountKey: this.getWrappedValue(this.fieldNameProvider.accountKey, e, this.getString),
          TradingAccountKey: this.getWrappedValue(this.fieldNameProvider.tradingAccountKey, e, this.getString),
          MarketKey: this.getWrappedValue(this.fieldNameProvider.marketKey, e, this.getString),
          MarketName: this.getWrappedValue(this.fieldNameProvider.marketName, e, this.getString),
          Quantity: this.getWrappedValue(this.fieldNameProvider.quantity, e, this.getNumber),
          BookingTime: this.getWrappedValue(this.fieldNameProvider.bookingTime, e, this.getDate),
          CurrentPrice: this.getWrappedValue(this.fieldNameProvider.currentPrice, e, this.getNumber),
          OpenPnl: this.getWrappedValue(this.fieldNameProvider.openPnl, e, this.getNumber),
          CurrencyId: this.getWrappedValue(this.fieldNameProvider.currencyId, e, this.getInt),
          MarginRequirement: this.getWrappedValue(this.fieldNameProvider.marginRequirement, e, this.getNumber),
          BookingPrice: this.getWrappedValue(this.fieldNameProvider.bookingPrice, e, this.getNumber),
          HasLinkedOrders: this.getWrappedValue(this.fieldNameProvider.hasLinkedOrders, e, this.getBoolean),
          Reference: this.getWrappedValue(this.fieldNameProvider.reference, e, this.getString),
          Status: this.getWrappedValue(this.fieldNameProvider.status, e, this.getTradeStatus),
          ClientRequestId: this.getWrappedValue(this.fieldNameProvider.clientRequestId, e, this.getString),
          ClientRequestReference: this.getWrappedValue(this.fieldNameProvider.clientRequestReference, e, this.getString),
          ValueDate: this.getWrappedValue(this.fieldNameProvider.valueDate, e, this.getOptionalDate),
          Consideration: this.getWrappedInIntermediateProperty(d),
          SubType: this.getWrappedValue(this.fieldNameProvider.subType, e, this.getTradeSubType)
        };
        return this.getDeserialisationResult(p, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.TradeDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e48 = function e(t, r) {
        return (_e48 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e48(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = {
          Time: this.getWrappedValue(this.fieldNameProvider.time, e, this.getDate),
          Key: this.getWrappedValue(this.fieldNameProvider.marketKey, e, this.getString),
          Open: this.getWrappedValue(this.fieldNameProvider.open, e, this.getNumber),
          Close: this.getWrappedValue(this.fieldNameProvider.close, e, this.getNumber),
          High: this.getWrappedValue(this.fieldNameProvider.high, e, this.getNumber),
          Low: this.getWrappedValue(this.fieldNameProvider.low, e, this.getNumber)
        };
        return this.getDeserialisationResult(t, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.CandleDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e49 = function e(t, r) {
        return (_e49 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e49(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = {
          Key: this.getWrappedValue(this.fieldNameProvider.priceKey, e, this.getString),
          Bid: this.getWrappedValue(this.fieldNameProvider.priceBid, e, this.getNumber),
          Ask: this.getWrappedValue(this.fieldNameProvider.priceAsk, e, this.getNumber),
          ChangeOnDay: this.getWrappedValue(this.fieldNameProvider.priceChangeOnDay, e, this.getNumber),
          ChangeOnDayPercentage: this.getWrappedValue(this.fieldNameProvider.priceChangeOnDayPercentage, e, this.getNumber),
          High: this.getWrappedValue(this.fieldNameProvider.priceHigh, e, this.getNumber),
          Low: this.getWrappedValue(this.fieldNameProvider.priceLow, e, this.getNumber)
        },
            r = {
          Trades: this.getWrappedValue(this.fieldNameProvider.acceptsTrades, e, this.getBoolean),
          Orders: this.getWrappedValue(this.fieldNameProvider.acceptsOrders, e, this.getBoolean)
        },
            n = {
          Key: this.getWrappedValue(this.fieldNameProvider.key, e, this.getString),
          Name: this.getWrappedValue(this.fieldNameProvider.name, e, this.getString),
          DecimalPlaces: this.getWrappedValue(this.fieldNameProvider.decimalPlaces, e, this.getInt),
          BetPer: this.getWrappedValue(this.fieldNameProvider.betPer, e, this.getNumber),
          TradeViaApi: this.getWrappedValue(this.fieldNameProvider.tradeViaApi, e, this.getBoolean),
          ExchangeKey: this.getWrappedValue(this.fieldNameProvider.exchangeKey, e, this.getString),
          MarketType: this.getWrappedValue(this.fieldNameProvider.marketType, e, this.getProductType),
          SettlementType: this.getWrappedValue(this.fieldNameProvider.settlementType, e, this.getSettlementType),
          Price: this.getWrappedInIntermediateProperty(t),
          Accepts: this.getWrappedInIntermediateProperty(r)
        };
        return this.getDeserialisationResult(n, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.MarketSummaryDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e50 = function e(t, r) {
        return (_e50 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e50(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.accountKey = "ak", t.cashBalance = "cb", t.openPnl = "op", t.netEquity = "ne", t.marginRequirement = "mr", t.availableBalance = "ab", t.credit = "ct", t.waivedDeposit = "wd", t.totalPosition = "tp", t.netOpenPositionLimit = "nopl", t.netOpenPosition = "nop", t.command = "command", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.accountKey, this.cashBalance, this.openPnl, this.netEquity, this.marginRequirement, this.availableBalance, this.credit, this.waivedDeposit, this.totalPosition, this.netOpenPositionLimit, this.netOpenPosition, this.command];
      }, t;
    }(r(5).FieldNameProvider);

    t.AccountResourcesFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e51 = function e(t, r) {
        return (_e51 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e51(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.requestKey = "rk", t.marketKey = "mk", t.marketName = "mn", t.rejectionReason = "rr", t.openedOrderInstructionKeyKey = "oo.ik.k", t.openedOrderOrderType = "oo.ot", t.openedOrderQuantity = "oo.q", t.openedOrderTriggerPrice = "oo.tp", t.openedOrderStatus = "oo.s", t.openedOrderLinkedTradeInstructionKeyKey = "oo.ltik.k", t.openedOrderCurrencyId = "oo.cid", t.openedOrderLevel = "oo.l", t.openedOrderContingentStopDistance = "oo.csd", t.openedOrderContingentLimitDistance = "oo.cld", t.openedOrderTrailingStep = "oo.ts", t.openedOrderTriggeringTime = "oo.tt", t.openedOrderIsGuaranteed = "oo.ig", t.openedOrderContingentIsGuaranteedStop = "oo.cigs", t.openedOrderReference = "oo.r", t.openedOrderExpiryDateTime = "oo.edt", t.openedOrderDistance = "oo.d", t.openedOrderGroupingOrders = "oo.g.os", t.openedOrderClientRequestId = "oo.crid", t.openedOrderClientRequestReference = "oo.crr", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.requestKey, this.marketKey, this.marketName, this.rejectionReason, this.openedOrderInstructionKeyKey, this.openedOrderOrderType, this.openedOrderQuantity, this.openedOrderTriggerPrice, this.openedOrderStatus, this.openedOrderLinkedTradeInstructionKeyKey, this.openedOrderCurrencyId, this.openedOrderLevel, this.openedOrderContingentStopDistance, this.openedOrderContingentLimitDistance, this.openedOrderTrailingStep, this.openedOrderTriggeringTime, this.openedOrderIsGuaranteed, this.openedOrderContingentIsGuaranteedStop, this.openedOrderReference, this.openedOrderExpiryDateTime, this.openedOrderDistance, this.openedOrderGroupingOrders, this.openedOrderClientRequestId, this.openedOrderClientRequestReference];
      }, t;
    }(r(5).FieldNameProvider);

    t.OrderBookingResponseFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e52 = function e(t, r) {
        return (_e52 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e52(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.requestKey = "rk", t.marketKey = "mk", t.marketName = "mn", t.rejectionReason = "rr", t.cancelledOrderInstructionKeyKey = "co.ik.k", t.cancelledOrderOrderType = "co.ot", t.cancelledOrderQuantity = "co.q", t.cancelledOrderTriggerPrice = "co.tp", t.cancelledOrderStatus = "co.s", t.cancelledOrderLinkedTradeInstructionKeyKey = "co.ltik.k", t.cancelledOrderCurrencyId = "co.cid", t.cancelledOrderLevel = "co.l", t.cancelledOrderContingentStopDistance = "co.csd", t.cancelledOrderContingentLimitDistance = "co.cld", t.cancelledOrderTrailingStep = "co.ts", t.cancelledOrderTriggeringTime = "co.tt", t.cancelledOrderIsGuaranteed = "co.ig", t.cancelledOrderContingentIsGuaranteedStop = "co.cigs", t.cancelledOrderReference = "co.r", t.cancelledOrderExpiryDateTime = "co.edt", t.cancelledOrderDistance = "co.d", t.cancelledOrderGroupingOrders = "co.g.os", t.cancelledOrderClientRequestId = "co.crid", t.cancelledOrderClientRequestReference = "co.crr", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.requestKey, this.marketKey, this.marketName, this.rejectionReason, this.cancelledOrderInstructionKeyKey, this.cancelledOrderOrderType, this.cancelledOrderQuantity, this.cancelledOrderTriggerPrice, this.cancelledOrderStatus, this.cancelledOrderLinkedTradeInstructionKeyKey, this.cancelledOrderCurrencyId, this.cancelledOrderLevel, this.cancelledOrderContingentStopDistance, this.cancelledOrderContingentLimitDistance, this.cancelledOrderTrailingStep, this.cancelledOrderTriggeringTime, this.cancelledOrderIsGuaranteed, this.cancelledOrderContingentIsGuaranteedStop, this.cancelledOrderReference, this.cancelledOrderExpiryDateTime, this.cancelledOrderDistance, this.cancelledOrderGroupingOrders, this.cancelledOrderClientRequestId, this.cancelledOrderClientRequestReference];
      }, t;
    }(r(5).FieldNameProvider);

    t.OrderCancellingResponseFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e53 = function e(t, r) {
        return (_e53 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e53(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.requestKey = "rk", t.marketKey = "mk", t.marketName = "mn", t.rejectionReason = "rr", t.editedOrderInstructionKeyKey = "eo.ik.k", t.editedOrderOrderType = "eo.ot", t.editedOrderQuantity = "eo.q", t.editedOrderTriggerPrice = "eo.tp", t.editedOrderStatus = "eo.s", t.editedOrderLinkedTradeInstructionKeyKey = "eo.ltik.k", t.editedOrderCurrencyId = "eo.cid", t.editedOrderLevel = "eo.l", t.editedOrderContingentStopDistance = "eo.csd", t.editedOrderContingentLimitDistance = "eo.cld", t.editedOrderTrailingStep = "eo.ts", t.editedOrderTriggeringTime = "eo.tt", t.editedOrderIsGuaranteed = "eo.ig", t.editedOrderContingentIsGuaranteedStop = "eo.cigs", t.editedOrderReference = "eo.r", t.editedOrderExpiryDateTime = "eo.edt", t.editedOrderDistance = "eo.d", t.editedOrderGroupingOrders = "eo.g.os", t.editedOrderClientRequestId = "eo.crid", t.editedOrderClientRequestReference = "eo.crr", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.requestKey, this.marketKey, this.marketName, this.rejectionReason, this.editedOrderInstructionKeyKey, this.editedOrderOrderType, this.editedOrderQuantity, this.editedOrderTriggerPrice, this.editedOrderStatus, this.editedOrderLinkedTradeInstructionKeyKey, this.editedOrderCurrencyId, this.editedOrderLevel, this.editedOrderContingentStopDistance, this.editedOrderContingentLimitDistance, this.editedOrderTrailingStep, this.editedOrderTriggeringTime, this.editedOrderIsGuaranteed, this.editedOrderContingentIsGuaranteedStop, this.editedOrderReference, this.editedOrderExpiryDateTime, this.editedOrderDistance, this.editedOrderGroupingOrders, this.editedOrderClientRequestId, this.editedOrderClientRequestReference];
      }, t;
    }(r(5).FieldNameProvider);

    t.OrderEditingResponseFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e54 = function e(t, r) {
        return (_e54 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e54(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyKey = "ik.k", t.accountKey = "ak", t.tradingAccountKey = "tak", t.marketKey = "mk", t.marketName = "mn", t.orderType = "ot", t.quantity = "q", t.triggerPrice = "tp", t.status = "s", t.linkedTradeInstructionKeyKey = "ltik.k", t.currencyId = "cid", t.level = "l", t.contingentStopDistance = "csd", t.contingentLimitDistance = "cld", t.trailingStep = "ts", t.triggeringTime = "tt", t.isGuaranteed = "ig", t.contingentIsGuaranteedStop = "cigs", t.reference = "r", t.expiryDateTime = "edt", t.bookingDate = "bd", t.groupingOrders = "g.os", t.clientRequestId = "crid", t.clientRequestReference = "crr", t.command = "command", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.instructionKeyKey, this.accountKey, this.tradingAccountKey, this.marketKey, this.marketName, this.orderType, this.quantity, this.triggerPrice, this.status, this.linkedTradeInstructionKeyKey, this.currencyId, this.level, this.contingentStopDistance, this.contingentLimitDistance, this.trailingStep, this.triggeringTime, this.isGuaranteed, this.contingentIsGuaranteedStop, this.reference, this.expiryDateTime, this.bookingDate, this.groupingOrders, this.clientRequestId, this.clientRequestReference, this.command];
      }, t;
    }(r(5).FieldNameProvider);

    t.OrderFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e55 = function e(t, r) {
        return (_e55 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e55(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.requestKey = "rk", t.marketKey = "mk", t.marketName = "mn", t.rejectionReason = "rr", t.openedTradeInstructionKeyKey = "ot.ik.k", t.openedTradeQuantity = "ot.q", t.openedTradeNewOpenQuantity = "ot.noq", t.openedTradeCurrencyId = "ot.cid", t.openedTradeTradePrice = "ot.tp", t.openedTradeRequestedPrice = "ot.rp", t.openedTradeReference = "ot.r", t.openedTradeMarketExpiry = "ot.me", t.openedTradeSlippage = "ot.s", t.openedTradeClientRequestId = "ot.crid", t.openedTradeClientRequestReference = "ot.crr", t.openedOrders = "oos", t.closedTrades = "cts", t.requestedQuantity = "rq", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.requestKey, this.marketKey, this.marketName, this.rejectionReason, this.openedTradeInstructionKeyKey, this.openedTradeQuantity, this.openedTradeNewOpenQuantity, this.openedTradeCurrencyId, this.openedTradeTradePrice, this.openedTradeRequestedPrice, this.openedTradeReference, this.openedTradeMarketExpiry, this.openedTradeSlippage, this.openedTradeClientRequestId, this.openedTradeClientRequestReference, this.openedOrders, this.closedTrades, this.requestedQuantity];
      }, t;
    }(r(5).FieldNameProvider);

    t.TradeBookingResponseFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e56 = function e(t, r) {
        return (_e56 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e56(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyKey = "ik.k", t.accountKey = "ak", t.tradingAccountKey = "tak", t.marketKey = "mk", t.marketName = "mn", t.quantity = "q", t.bookingTime = "bt", t.currentPrice = "cp", t.openPnl = "op", t.currencyId = "cid", t.marginRequirement = "mr", t.bookingPrice = "bp", t.hasLinkedOrders = "hlo", t.reference = "r", t.status = "s", t.clientRequestId = "crid", t.clientRequestReference = "crr", t.valueDate = "vd", t.considerationBaseConsiderationValue = "c.bc.v", t.considerationBaseConsiderationCurrencyId = "c.bc.cid", t.considerationDeliveryConsiderationValue = "c.dc.v", t.considerationDeliveryConsiderationCurrencyId = "c.dc.cid", t.subType = "st", t.command = "command", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.instructionKeyKey, this.accountKey, this.tradingAccountKey, this.marketKey, this.marketName, this.quantity, this.bookingTime, this.currentPrice, this.openPnl, this.currencyId, this.marginRequirement, this.bookingPrice, this.hasLinkedOrders, this.reference, this.status, this.clientRequestId, this.clientRequestReference, this.valueDate, this.considerationBaseConsiderationValue, this.considerationBaseConsiderationCurrencyId, this.considerationDeliveryConsiderationValue, this.considerationDeliveryConsiderationCurrencyId, this.subType, this.command];
      }, t;
    }(r(5).FieldNameProvider);

    t.TradeFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e57 = function e(t, r) {
        return (_e57 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e57(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.time = "t", t.marketKey = "mk", t.open = "o", t.close = "c", t.high = "h", t.low = "l", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.time, this.marketKey, this.open, this.close, this.high, this.low];
      }, t;
    }(r(5).FieldNameProvider);

    t.CandleFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e58 = function e(t, r) {
        return (_e58 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e58(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.key = "k", t.name = "n", t.decimalPlaces = "dp", t.betPer = "bp", t.tradeViaApi = "tva", t.exchangeKey = "ek", t.marketType = "mt", t.settlementType = "st", t.priceKey = "p.k", t.priceBid = "p.b", t.priceAsk = "p.a", t.priceChangeOnDay = "p.cod", t.priceChangeOnDayPercentage = "p.codp", t.priceHigh = "p.h", t.priceLow = "p.l", t.acceptsTrades = "a.t", t.acceptsOrders = "a.o", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.key, this.name, this.decimalPlaces, this.betPer, this.tradeViaApi, this.exchangeKey, this.marketType, this.settlementType, this.priceKey, this.priceBid, this.priceAsk, this.priceChangeOnDay, this.priceChangeOnDayPercentage, this.priceHigh, this.priceLow, this.acceptsTrades, this.acceptsOrders];
      }, t;
    }(r(5).FieldNameProvider);

    t.MarketSummaryFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      function e(e, t, r) {
        this.description = e, this.fieldNameProvider = t, this.groupKey = r;
      }

      return e.prototype.create = function (e) {
        var t = new Lightstreamer.Subscription(this.description.subscriptionMode, this.getGroup(), this.fieldNameProvider.getFieldNames());
        return t.setDataAdapter(this.description.dataAdapter), t.setRequestedSnapshot(this.description.requestPushSnapshot ? "yes" : "no"), t.setRequestedMaxFrequency("DISTINCT" === this.description.subscriptionMode ? "unfiltered" : this.description.updateMaxFrequency || 3), t.addListener(e), t;
      }, e.prototype.createStructureSubscription = function (e) {
        var t = new Lightstreamer.Subscription("COMMAND", "SRU" + this.getGroup(), ["key", "command"]);
        return t.setDataAdapter("Structure"), t.setRequestedSnapshot("no"), t.addListener(e), t;
      }, e.prototype.getGroup = function () {
        return this.description.groupName + "#" + this.groupKey;
      }, e;
    }();

    t.LightstreamerPushSubscriptionFactory = n;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(107),
        i = r(18),
        o = r(108),
        a = r(109),
        s = r(21),
        u = r(114),
        c = r(119),
        d = function () {
      function e(e, t, r) {
        this.connectionStatusListener = t, this.connectionErrorListener = r, this.connectionStatus = i.PushConnectionStatus.Disconnected, this.lightstreamerClient = this.createLightstreamerClient(e);
      }

      return e.prototype.connect = function () {
        this.lightstreamerClient.connect();
      }, e.prototype.disconnect = function () {
        this.lightstreamerClient.disconnect();
      }, e.prototype.createDistinctPushStream = function (e, t, r, n, i) {
        return new a.DistinctPushStream(this.lightstreamerClient, e, t, r, n, i);
      }, e.prototype.createMergePushStream = function (e, t, r, n, i, o, a, u) {
        return new s.MergePushStream(this.lightstreamerClient, e, t, r, n, i, o, a, u);
      }, e.prototype.createMergeWithStructurePushStream = function (e, t, r, n, i, o, a) {
        return new c.MergeWithStructurePushStream(this.lightstreamerClient, e, t, r, n, i, o, a);
      }, e.prototype.createCommandPushStream = function (e, t, r, n, i, o, a, s) {
        return new u.CommandPushStream(this.lightstreamerClient, e, t, r, n, i, a, o, s);
      }, e.prototype.onServerError = function (e, t) {
        var r = n.convertConnectionError(e);
        this.connectionErrorListener(r, t);
      }, e.prototype.onStatusChange = function (e) {
        this.connectionStatus = o.parsePushConnectionStatus(e, this.connectionStatus), this.connectionStatusListener(this.connectionStatus);
      }, e.prototype.createLightstreamerClient = function (e) {
        var t = this,
            r = e.IsHttps ? "https" : "http",
            n = e.IsHttps ? e.HttpsPort : e.Port,
            i = r + "://" + e.Host + ":" + n,
            o = new Lightstreamer.LightstreamerClient(i, e.AdapterSet);
        o.connectionDetails.setUser(e.AuthenticationCredentials.Username), o.connectionDetails.setPassword(e.AuthenticationCredentials.Password);
        var a = {
          onServerError: function onServerError(e, r) {
            return t.onServerError(e, r);
          },
          onStatusChange: function onStatusChange(e) {
            return t.onStatusChange(e);
          }
        };
        return o.addListener(a), o;
      }, e;
    }();

    t.PushConnection = d;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(14);

    t.convertConnectionError = function (e) {
      switch (e) {
        case 1:
          return n.PushConnectionError.AuthenticationError;

        default:
          return n.PushConnectionError.ServerError;
      }
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n,
        i = r(18);
    t.parsePushConnectionStatus = function (e, t) {
      switch (e) {
        case n.Connecting:
          return t === i.PushConnectionStatus.Reconnecting ? i.PushConnectionStatus.Reconnecting : i.PushConnectionStatus.Connecting;

        case n.DisconnectedWillRetry:
        case n.DisconnectedTryingRecovery:
          return i.PushConnectionStatus.Reconnecting;

        case n.Disconnected:
          return i.PushConnectionStatus.Disconnected;

        case n.ConnectedStreamSensing:
        case n.ConnectedWebSocketStreaming:
        case n.ConnectedHttpStreaming:
        case n.ConnectedWebSocketPolling:
        case n.ConnectedHttpPolling:
          return i.PushConnectionStatus.Connected;

        default:
          throw new Error("LS Library incompatible: Unknown Lightstreamer Status value=" + e);
      }
    }, function (e) {
      e.Connecting = "CONNECTING", e.DisconnectedWillRetry = "DISCONNECTED:WILL-RETRY", e.DisconnectedTryingRecovery = "DISCONNECTED:TRYING-RECOVERY", e.Disconnected = "DISCONNECTED", e.ConnectedStreamSensing = "CONNECTED:STREAM-SENSING", e.ConnectedWebSocketStreaming = "CONNECTED:WS-STREAMING", e.ConnectedHttpStreaming = "CONNECTED:HTTP-STREAMING", e.ConnectedWebSocketPolling = "CONNECTED:WS-POLLING", e.ConnectedHttpPolling = "CONNECTED:HTTP-POLLING";
    }(n = t.LighstreamerConnectionStatusNames || (t.LighstreamerConnectionStatusNames = {}));
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e59 = function e(t, r) {
        return (_e59 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e59(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(19),
        o = r(8),
        a = function (e) {
      function t(t, r, n, i, o, a) {
        var s = e.call(this, t, r, n, o, a) || this;
        return s.dataTransformer = i, s;
      }

      return n(t, e), t.prototype.onDeserialisedUpdate = function (e) {
        var t = this.dataTransformer.transform(e.result);
        this.onUpdate([{
          update: t,
          type: o.StreamUpdateType.Distinct
        }]);
      }, t;
    }(i.PushStreamBase);

    t.DistinctPushStream = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e60 = function e(t, r) {
        return (_e60 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e60(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(t, r, n, i, o) {
        var a = e.call(this, t) || this;
        return a.subscriptionFactory = r, a.deserialiser = n, a.onSubscription = o, a.onUpdate = i, a;
      }

      return n(t, e), t.prototype.createSubscription = function () {
        var e = this,
            t = {
          onSubscription: function onSubscription() {
            return e.onSubscription();
          },
          onItemUpdate: function onItemUpdate(t) {
            var r = e.deserialiser.deserialise(t);
            e.onUpdate(r);
          }
        };
        return this.subscriptionFactory.create(t);
      }, t;
    }(r(20).PushSubscriptionBase);

    t.DeserialisingPushSubscription = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e61 = function e(t, r) {
        return (_e61 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e61(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        i = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.getInitialData = function () {
        return i(this, void 0, void 0, function () {
          var e, t, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.requestSnapshot()];

              case 1:
                return e = n.sent(), t = this.convertSnapshotToVersionData(e), this.validateSnapshotToUpdates(t), r = this.combineSnapshotPlusUpdates(t), [2, new Map(Array.from(r.entries()).map(function (e) {
                  return [e[0], e[1]];
                }))];
            }
          });
        });
      }, t.prototype.combineSnapshotPlusUpdates = function (e) {
        var t = this,
            r = this.sequenceNumberSorter.sortBySequenceNumber(this.updates),
            n = new Map(e.map(function (e) {
          return [t.keySelector(e.data), e];
        }));
        return r.forEach(function (e) {
          var r = n.get(e.key);
          if (void 0 === r) throw new Error("Push update recieved for item not in REST snapshot. Key=" + e.key);

          if (e.sequenceNumber.Number.gt(r.sequenceNumber.Number)) {
            var i = t.dataCombiner.combine(r.data, e.intermediate);
            n.set(e.key, {
              key: e.key,
              data: i,
              sequenceNumber: e.sequenceNumber
            });
          }
        }), n;
      }, t;
    }(r(22).SnapshotManager);

    t.FixedStructureSnapshotManager = a;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      function e(e) {
        this.sequenceNumberExtractor = e;
      }

      return e.prototype.sortBySequenceNumber = function (e) {
        var t = this;
        return e.sort(function (e, r) {
          return t.sortBySequenceNumberCompare(e, r);
        });
      }, e.prototype.sortBySequenceNumberCompare = function (e, t) {
        var r = this.sequenceNumberExtractor(e),
            n = this.sequenceNumberExtractor(t);
        return r.Number.lt(n.Number) ? -1 : r.Number.gt(n.Number) ? 1 : 0;
      }, e;
    }();

    t.SequenceNumberSorter = n;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      function e() {}

      return e.prototype.updateAndCheckIsEraValid = function (e) {
        var t;
        return t = void 0 === this.currentEra || e.eq(this.currentEra), this.update(e), t;
      }, e.prototype.update = function (e) {
        e.eq(0) || (this.currentEra = e);
      }, e.prototype.clear = function () {
        this.currentEra = void 0;
      }, e;
    }();

    t.EraManager = n;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e62 = function e(t, r) {
        return (_e62 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e62(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        i = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(8),
        s = r(115),
        u = r(117),
        c = r(118),
        d = function (e) {
      function t(t, r, n, i, o, a, s, u, d) {
        var p = e.call(this, t, r, n, a, new c.AddingAndUpdatingDataStore(i, o), u) || this;
        return p.dataCombiner = i, p.dataTransformer = o, p.requestSnapshot = d, p.keyExtractor = s, p;
      }

      return n(t, e), t.prototype.onDeserialisedUpdate = function (e) {
        var t = s.CommandDeserialiser.deserialiseUpdateType(e.input);
        if (!this.handleChangeInEra(e.sequenceNumber.Era)) if (void 0 === this.snapshotManager) switch (t) {
          case a.StreamUpdateType.Add:
            var r = this.dataStore.add(e.key, e.result, e.sequenceNumber);
            this.onUpdate([{
              update: r.data,
              type: t
            }]);
            break;

          case a.StreamUpdateType.Update:
            var n = this.dataStore.update(e.key, e.result, e.sequenceNumber);
            this.onUpdate([{
              update: n.data,
              type: t
            }]);
            break;

          case a.StreamUpdateType.Delete:
            var i = this.dataStore.remove(e.key, e.result, e.sequenceNumber);
            this.onUpdate([{
              update: i.data,
              type: t
            }]);
            break;

          default:
            throw new Error("updateType=" + t + " not recognised");
        } else this.snapshotManager.processUpdate(e.key, e.result, e.sequenceNumber, t);
      }, t.prototype.onSubscription = function () {
        return i(this, void 0, void 0, function () {
          var t, r, n, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return e.prototype.onSubscription.call(this), void 0 === this.requestSnapshot ? [2] : (this.snapshotManager = new u.ChangingStructureSnapshotManager(this.requestSnapshot, this.keyExtractor, this.dataCombiner, this.dataTransformer), [4, this.getSnapshotEraResult()]);

              case 1:
                return (t = o.sent()).success ? (r = t.snapshot, void 0 === this.snapshotManager ? [2] : (this.dataStore.setInitialData(r), (n = Array.from(r.values())).length > 0 && this.updateEra(n[0].sequenceNumber.Era), this.snapshotManager = void 0, i = n.map(function (e) {
                  return {
                    update: e.data,
                    type: a.StreamUpdateType.Add
                  };
                }), this.onUpdate(i), [2])) : [2];
            }
          });
        });
      }, t;
    }(r(24).EraAwarePushStream);

    t.CommandPushStream = d;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(116),
        i = function () {
      function e() {}

      return e.deserialiseUpdateType = function (e) {
        var t = e.getValue("command");
        return n.CommandToUpdateTypeConverter.convert(t);
      }, e;
    }();

    t.CommandDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(8),
        i = function () {
      function e() {}

      return e.convert = function (e) {
        switch (e) {
          case "ADD":
            return n.StreamUpdateType.Add;

          case "UPDATE":
            return n.StreamUpdateType.Update;

          case "DELETE":
            return n.StreamUpdateType.Delete;

          default:
            throw new Error("No conversion exists for command=" + e);
        }
      }, e;
    }();

    t.CommandToUpdateTypeConverter = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e63 = function e(t, r) {
        return (_e63 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e63(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        i = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(8),
        s = function (e) {
      function t(t, r, n, i) {
        var o = e.call(this, t, r, n) || this;
        return o.dataTransformer = i, o;
      }

      return n(t, e), t.prototype.getInitialData = function () {
        return i(this, void 0, void 0, function () {
          var e, t, r, n;
          return o(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.requestSnapshot()];

              case 1:
                return e = i.sent(), t = this.convertSnapshotToVersionData(e), this.validateSnapshotToUpdates(t), r = this.combineSnapshotPlusUpdates(t), n = this.removeDeletedItems(r), [2, new Map(Array.from(n.entries()).map(function (e) {
                  return [e[0], e[1]];
                }))];
            }
          });
        });
      }, t.prototype.getAddsAndUpdates = function () {
        return this.updates.filter(function (e) {
          return e.type === a.StreamUpdateType.Add || e.type === a.StreamUpdateType.Update;
        });
      }, t.prototype.getDeletes = function () {
        return this.updates.filter(function (e) {
          return e.type === a.StreamUpdateType.Delete;
        });
      }, t.prototype.combineSnapshotPlusUpdates = function (e) {
        var t = this,
            r = this.sequenceNumberSorter.sortBySequenceNumber(this.getAddsAndUpdates()),
            n = new Map(e.map(function (e) {
          return [t.keySelector(e.data), e];
        }));
        return r.forEach(function (e) {
          var r = n.get(e.key);

          if (r) {
            if (e.sequenceNumber.Number.gt(r.sequenceNumber.Number)) {
              var i = t.dataCombiner.combine(r.data, e.intermediate);
              n.set(e.key, {
                key: e.key,
                data: i,
                sequenceNumber: e.sequenceNumber
              });
            }
          } else {
            var o = t.dataTransformer.transform(e.intermediate);
            n.set(e.key, {
              key: e.key,
              data: o,
              sequenceNumber: e.sequenceNumber
            });
          }
        }), n;
      }, t.prototype.removeDeletedItems = function (e) {
        var t = new Map(e.entries());
        return this.getDeletes().forEach(function (e) {
          return t.delete(e.key);
        }), t;
      }, t;
    }(r(22).SnapshotManager);

    t.ChangingStructureSnapshotManager = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e64 = function e(t, r) {
        return (_e64 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e64(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(t, r) {
        var n = e.call(this, t) || this;
        return n.dataTransformer = r, n;
      }

      return n(t, e), t.prototype.add = function (e, t, r) {
        var n = {
          key: e,
          data: this.dataTransformer.transform(t),
          sequenceNumber: r
        };
        return this.currentData.set(e, n), n;
      }, t;
    }(r(25).UpdatingDataStore);

    t.AddingAndUpdatingDataStore = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e65 = function e(t, r) {
        return (_e65 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e65(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        i = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = r(21),
        s = r(120),
        u = r(121),
        c = r(8),
        d = function (e) {
      function t(t, r, n, i, o, a, u, c) {
        var d = e.call(this, t, r, n, i, o, a, u, c) || this;
        return d.structureSubscription = new s.StructurePushSubscription(t, r, function () {
          return d.onStructureSubscription();
        }, function () {
          return d.onStructureUpdate();
        }), d;
      }

      return n(t, e), t.prototype.start = function () {
        this.structureSubscription.start();
      }, t.prototype.stop = function () {
        this.structureSubscription.stop(), e.prototype.stop.call(this);
      }, t.prototype.onSubscription = function () {
        return i(this, void 0, void 0, function () {
          var t, r, n, i, a, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return this.structureChangeContext ? [3, 2] : [4, e.prototype.onSubscription.call(this)];

              case 1:
                return o.sent(), [2];

              case 2:
                return [4, this.getSnapshot()];

              case 3:
                return void 0 === (t = o.sent()) ? (this.structureChangeContext = void 0, [2]) : (r = u.StructureUpdateComparer.compare(this.structureChangeContext.preChangeData, t), this.dataStore.setInitialData(t), n = r.added.map(function (e) {
                  return {
                    update: e.data,
                    type: c.StreamUpdateType.Add
                  };
                }), i = r.updated.map(function (e) {
                  return {
                    update: e.data,
                    type: c.StreamUpdateType.Update
                  };
                }), a = r.deleted.map(function (e) {
                  return {
                    update: e.data,
                    type: c.StreamUpdateType.Delete
                  };
                }), s = n.concat(i, a), this.onUpdate(s), this.structureChangeContext = void 0, [2]);
            }
          });
        });
      }, t.prototype.onStructureSubscription = function () {
        e.prototype.start.call(this);
      }, t.prototype.onStructureUpdate = function () {
        return i(this, void 0, void 0, function () {
          var t;
          return o(this, function (r) {
            return t = this.getEntriesAndStop(), this.structureChangeContext = {
              preChangeData: t
            }, e.prototype.start.call(this), [2];
          });
        });
      }, t;
    }(a.MergePushStream);

    t.MergeWithStructurePushStream = d;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e66 = function e(t, r) {
        return (_e66 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e66(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t(t, r, n, i) {
        var o = e.call(this, t) || this;
        return o.subscriptionFactory = r, o.onSubscription = n, o.onUpdate = i, o;
      }

      return n(t, e), t.prototype.createSubscription = function () {
        var e = this,
            t = {
          onSubscription: function onSubscription() {
            return e.onSubscription();
          },
          onItemUpdate: function onItemUpdate(t) {
            e.onUpdate();
          }
        };
        return this.subscriptionFactory.createStructureSubscription(t);
      }, t;
    }(r(20).PushSubscriptionBase);

    t.StructurePushSubscription = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      function e() {}

      return e.compare = function (e, t) {
        var r = Array.from(t.keys()).filter(function (t) {
          return !e.has(t);
        }).map(function (e) {
          return t.get(e);
        }),
            n = Array.from(e.keys()).filter(function (e) {
          return !t.has(e);
        }).map(function (t) {
          return e.get(t);
        });
        return {
          added: r,
          updated: Array.from(t.values()).filter(function (t) {
            var r = e.get(t.key);
            return void 0 !== r && (!t.sequenceNumber.Era.eq(r.sequenceNumber.Era) || !!t.sequenceNumber.Number.gt(r.sequenceNumber.Number));
          }),
          deleted: n
        };
      }, e;
    }();

    t.StructureUpdateComparer = n;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e.Merge = "MERGE", e.Command = "COMMAND", e.Distinct = "DISTINCT";
    }(t.LightstreamerMode || (t.LightstreamerMode = {}));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      function e() {}

      return e.prototype.getHeadersForJsonResponse = function (e, t, r) {
        var n = this.getJsonHeaders(),
            i = this.getHeadersForRawResponse(e, t, r);
        return n.concat(i);
      }, e.prototype.getHeadersForRawResponse = function (e, t, r) {
        var n = [this.getApiVersionHeader()];
        return null != e && n.push(["Authorization", "Broker " + e]), null != t && n.push(["X-API-TradingAccountKey", t.toString()]), null != r && n.push(["X-API-ProductType", r.toString()]), n;
      }, e.prototype.getJsonHeaders = function () {
        return [["Content-Type", "application/json"], ["Accept", "application/json"]];
      }, e.prototype.getApiVersionHeader = function () {
        return ["X-API-Version", "v001"];
      }, e;
    }();

    t.HeaderFactory = n;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function () {
      return function (e, t) {
        this.response = e, this.text = t;
      };
    }();

    t.RequestResponse = n;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(17),
        i = function () {
      function e() {}

      return e.prototype.parseSequenceNumbers = function (e) {
        for (var t = [], r = /"SequenceNumber":\s*\{\s*"Era":\s*(\d+),\s*"Number":\s*(\d+)\s*\}/g, i = r.exec(e); null != i;) {
          t.push({
            Era: new n.default(i[1]),
            Number: new n.default(i[2])
          }), i = r.exec(e);
        }

        return t;
      }, e;
    }();

    t.SequenceNumberParser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e67 = function e(t, r) {
        return (_e67 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e67(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Username: e.Username,
          Password: e.Password
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.LightstreamerAuthenticationCredentialsRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e68 = function e(t, r) {
        return (_e68 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e68(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(11),
        a = r(128),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.tradingAccountRestDeserialiser = new a.TradingAccountRestDeserialiser(), t.currencyRestDeserialiser = new o.CurrencyRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          Key: e.Key,
          Name: e.Name,
          TradingAccounts: e.TradingAccounts.map(function (e) {
            return t.tradingAccountRestDeserialiser.deserialise(e);
          }),
          UtcOffsetMinutes: e.UtcOffsetMinutes,
          PreferredLanguageCode: e.PreferredLanguageCode,
          Currency: this.currencyRestDeserialiser.deserialise(e.Currency),
          LinkedTradingAccounts: e.LinkedTradingAccounts.map(function (e) {
            return t.tradingAccountRestDeserialiser.deserialise(e);
          }),
          AccountCode: e.AccountCode
        };
      }, t;
    }(i.RestDeserialiser);

    t.AccountRestDeserialiser = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e69 = function e(t, r) {
        return (_e69 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e69(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(11),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.currencyRestDeserialiser = new o.CurrencyRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          Key: e.Key,
          AccountKey: e.AccountKey,
          AccountType: e.AccountType,
          Currencies: e.Currencies.map(function (e) {
            return t.currencyRestDeserialiser.deserialise(e);
          }),
          AccountCode: e.AccountCode
        };
      }, t;
    }(i.RestDeserialiser);

    t.TradingAccountRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e70 = function e(t, r) {
        return (_e70 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e70(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(130),
        a = r(131),
        s = r(132),
        u = r(133),
        c = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.authenticationRestDeserialiser = new o.AuthenticationRestDeserialiser(), t.configurationRestDeserialiser = new s.ConfigurationRestDeserialiser(), t.accountRestrictionsRestDeserialiser = new a.AccountRestrictionsRestDeserialiser(), t.tradingAccountTokenRestDeserialiser = new u.TradingAccountTokenRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          Authentication: this.authenticationRestDeserialiser.deserialise(e.Authentication),
          Configuration: this.configurationRestDeserialiser.deserialise(e.Configuration),
          AccountRestrictions: this.accountRestrictionsRestDeserialiser.deserialise(e.AccountRestrictions),
          TradingAccountSessionTokens: e.TradingAccountSessionTokens.map(function (e) {
            return t.tradingAccountTokenRestDeserialiser.deserialise(e);
          })
        };
      }, t;
    }(i.RestDeserialiser);

    t.AuthenticationResponseRestDeserialiser = c;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e71 = function e(t, r) {
        return (_e71 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e71(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(28),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.lightstreamerConfigurationRestDeserialiser = new o.LightstreamerConfigurationRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          AgentKey: e.AgentKey,
          ClientAccountKey: e.ClientAccountKey,
          AccountOperatorKey: e.AccountOperatorKey,
          Token: e.Token,
          LightstreamerConfiguration: this.lightstreamerConfigurationRestDeserialiser.deserialise(e.LightstreamerConfiguration),
          SsoToken: e.SsoToken,
          Username: e.Username
        };
      }, t;
    }(i.RestDeserialiser);

    t.AuthenticationRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e72 = function e(t, r) {
        return (_e72 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e72(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          CanTrade: e.CanTrade,
          CanPlaceOrder: e.CanPlaceOrder
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.AccountRestrictionsRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e73 = function e(t, r) {
        return (_e73 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e73(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(11),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.currencyRestDeserialiser = new o.CurrencyRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          ForceMarketBaseCurrencyForCfds: e.ForceMarketBaseCurrencyForCfds,
          Currencies: this.deserialiseDictionary(e.Currencies, parseInt, this.currencyRestDeserialiser.deserialise),
          ChartsAvailable: e.ChartsAvailable
        };
      }, t;
    }(i.RestDeserialiser);

    t.ConfigurationRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e74 = function e(t, r) {
        return (_e74 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e74(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          TradingAccountKey: e.TradingAccountKey,
          Token: e.Token
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.TradingAccountTokenRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e75 = function e(t, r) {
        return (_e75 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e75(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(6),
        a = r(135),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new o.InstructionKeyRestDeserialiser(), t.orderGroupingRestDeserialiser = new a.OrderGroupingRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          InstructionKey: this.instructionKeyRestDeserialiser.deserialise(e.InstructionKey),
          AccountKey: e.AccountKey,
          TradingAccountKey: e.TradingAccountKey,
          MarketKey: e.MarketKey,
          MarketName: e.MarketName,
          OrderType: e.OrderType,
          Quantity: parseFloat(e.Quantity),
          TriggerPrice: parseFloat(e.TriggerPrice),
          Status: e.Status,
          LinkedTradeInstructionKey: null !== e.LinkedTradeInstructionKey ? this.instructionKeyRestDeserialiser.deserialise(e.LinkedTradeInstructionKey) : void 0,
          CurrencyId: e.CurrencyId,
          Level: parseFloat(e.Level),
          ContingentStopDistance: null !== e.ContingentStopDistance ? parseFloat(e.ContingentStopDistance) : void 0,
          ContingentLimitDistance: null !== e.ContingentLimitDistance ? parseFloat(e.ContingentLimitDistance) : void 0,
          TrailingStep: null !== e.TrailingStep ? parseFloat(e.TrailingStep) : void 0,
          TriggeringTime: null !== e.TriggeringTime ? new Date(e.TriggeringTime) : void 0,
          IsGuaranteed: e.IsGuaranteed,
          ContingentIsGuaranteedStop: e.ContingentIsGuaranteedStop,
          Reference: e.Reference,
          ExpiryDateTime: null !== e.ExpiryDateTime ? new Date(e.ExpiryDateTime) : void 0,
          BookingDate: new Date(e.BookingDate),
          Grouping: null !== e.Grouping ? this.orderGroupingRestDeserialiser.deserialise(e.Grouping) : void 0,
          ClientRequestId: null !== e.ClientRequestId ? e.ClientRequestId : void 0,
          ClientRequestReference: null !== e.ClientRequestReference ? e.ClientRequestReference : void 0
        };
      }, t;
    }(i.RestDeserialiser);

    t.OrderRestDeserialiser = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e76 = function e(t, r) {
        return (_e76 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e76(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(6),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new o.InstructionKeyRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          Orders: e.Orders.map(function (e) {
            return t.instructionKeyRestDeserialiser.deserialise(e);
          })
        };
      }, t;
    }(i.RestDeserialiser);

    t.OrderGroupingRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e77 = function e(t, r) {
        return (_e77 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e77(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(12),
        a = r(6),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new a.InstructionKeyRestDeserialiser(), t.considerationRestDeserialiser = new o.ConsiderationRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          InstructionKey: this.instructionKeyRestDeserialiser.deserialise(e.InstructionKey),
          AccountKey: e.AccountKey,
          TradingAccountKey: e.TradingAccountKey,
          MarketKey: e.MarketKey,
          MarketName: e.MarketName,
          Quantity: parseFloat(e.Quantity),
          BookingTime: new Date(e.BookingTime),
          CurrentPrice: parseFloat(e.CurrentPrice),
          OpenPnl: parseFloat(e.OpenPnl),
          CurrencyId: e.CurrencyId,
          MarginRequirement: parseFloat(e.MarginRequirement),
          BookingPrice: parseFloat(e.BookingPrice),
          HasLinkedOrders: e.HasLinkedOrders,
          Reference: e.Reference,
          Status: e.Status,
          ClientRequestId: e.ClientRequestId,
          ClientRequestReference: e.ClientRequestReference,
          ValueDate: null !== e.ValueDate ? new Date(e.ValueDate) : void 0,
          Consideration: this.considerationRestDeserialiser.deserialise(e.Consideration),
          SubType: e.SubType
        };
      }, t;
    }(i.RestDeserialiser);

    t.TradeRestDeserialiser = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e78 = function e(t, r) {
        return (_e78 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e78(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Value: parseFloat(e.Value),
          CurrencyId: e.CurrencyId
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.ConsiderationValueRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e79 = function e(t, r) {
        return (_e79 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e79(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Time: new Date(e.Time),
          Key: e.Key,
          Open: parseFloat(e.Open),
          Close: parseFloat(e.Close),
          High: parseFloat(e.High),
          Low: parseFloat(e.Low)
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.CandleRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e80 = function e(t, r) {
        return (_e80 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e80(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(140),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.marketListKeyRestDeserialiser = new o.MarketListKeyRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          Key: this.marketListKeyRestDeserialiser.deserialise(e.Key),
          Name: e.Name,
          IsDefault: e.IsDefault,
          ParentKey: null !== e.ParentKey ? this.marketListKeyRestDeserialiser.deserialise(e.ParentKey) : void 0,
          Children: null !== e.Children ? e.Children.map(function (e) {
            return t.deserialise(e);
          }) : void 0,
          MarketKeys: e.MarketKeys
        };
      }, t;
    }(i.RestDeserialiser);

    t.MarketListRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e81 = function e(t, r) {
        return (_e81 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e81(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Type: e.Type,
          Key: e.Key
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.MarketListKeyRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e82 = function e(t, r) {
        return (_e82 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e82(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(142),
        a = r(144),
        s = r(145),
        u = r(147),
        c = r(29),
        d = r(148),
        p = r(150),
        l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.underlyingBreakRestDeserialiser = new p.UnderlyingBreakRestDeserialiser(), t.marketPriceRestDeserialiser = new d.MarketPriceRestDeserialiser(), t.marginRestDeserialiser = new s.MarginRestDeserialiser(), t.marketBookingStatusRestDeserialiser = new c.MarketBookingStatusRestDeserialiser(), t.financingRestDeserialiser = new o.FinancingRestDeserialiser(), t.fxCurrenciesRestDeserialiser = new a.FxCurrenciesRestDeserialiser(), t.marginSettingsRestDeserialiser = new u.MarginSettingsRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          Key: e.Key,
          Name: e.Name,
          MarketType: e.MarketType,
          LifecycleType: e.LifecycleType,
          UnderlyingType: e.UnderlyingType,
          CurrencyId: e.CurrencyId,
          DecimalPlaces: e.DecimalPlaces,
          MaxStake: parseFloat(e.MaxStake),
          MinStake: parseFloat(e.MinStake),
          BetPer: parseFloat(e.BetPer),
          AllowSimpleOrders: e.AllowSimpleOrders,
          AllowContingentOrders: e.AllowContingentOrders,
          AllowTrailingOrders: e.AllowTrailingOrders,
          BasisOfExpiry: e.BasisOfExpiry,
          BasisOfLastTrading: e.BasisOfLastTrading,
          RolloverDate: null !== e.RolloverDate ? new Date(e.RolloverDate) : void 0,
          LastTradingDate: null !== e.LastTradingDate ? new Date(e.LastTradingDate) : void 0,
          IsTwentyFourHours: e.IsTwentyFourHours,
          MarketOpenTime: null !== e.MarketOpenTime ? e.MarketOpenTime : void 0,
          MarketCloseTime: null !== e.MarketCloseTime ? e.MarketCloseTime : void 0,
          GuaranteedMinDistance: parseFloat(e.GuaranteedMinDistance),
          GuaranteedMinDistanceType: e.GuaranteedMinDistanceType,
          ExchangeKey: e.ExchangeKey,
          SettlementType: e.SettlementType,
          UnderlyingBreaks: e.UnderlyingBreaks.map(function (e) {
            return t.underlyingBreakRestDeserialiser.deserialise(e);
          }),
          Price: this.marketPriceRestDeserialiser.deserialise(e.Price),
          ExpiryDate: null !== e.ExpiryDate ? new Date(e.ExpiryDate) : void 0,
          Margin: this.marginRestDeserialiser.deserialise(e.Margin),
          Accepts: this.marketBookingStatusRestDeserialiser.deserialise(e.Accepts),
          FinancingLongHaircut: this.financingRestDeserialiser.deserialise(e.FinancingLongHaircut),
          FinancingShortHaircut: this.financingRestDeserialiser.deserialise(e.FinancingShortHaircut),
          LotSize: parseFloat(e.LotSize),
          GuaranteedStops: e.GuaranteedStops,
          FxCurrencies: null !== e.FxCurrencies ? this.fxCurrenciesRestDeserialiser.deserialise(e.FxCurrencies) : void 0,
          MarginSettings: this.marginSettingsRestDeserialiser.deserialise(e.MarginSettings)
        };
      }, t;
    }(i.RestDeserialiser);

    t.MarketRestDeserialiser = l;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e83 = function e(t, r) {
        return (_e83 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e83(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(143),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.financingBandRestDeserialiser = new o.FinancingBandRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          UnitType: e.UnitType,
          FinancingBands: e.FinancingBands.map(function (e) {
            return t.financingBandRestDeserialiser.deserialise(e);
          })
        };
      }, t;
    }(i.RestDeserialiser);

    t.FinancingRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e84 = function e(t, r) {
        return (_e84 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e84(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          LowerLimit: e.LowerLimit,
          Amount: parseFloat(e.Amount)
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.FinancingBandRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e85 = function e(t, r) {
        return (_e85 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e85(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          BaseCurrencyId: e.BaseCurrencyId,
          DeliveryCurrencyId: e.DeliveryCurrencyId
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.FxCurrenciesRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e86 = function e(t, r) {
        return (_e86 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e86(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(146),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.marginBandRestDeserialiser = new o.MarginBandRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          UnitType: e.UnitType,
          MarginBands: e.MarginBands.map(function (e) {
            return t.marginBandRestDeserialiser.deserialise(e);
          })
        };
      }, t;
    }(i.RestDeserialiser);

    t.MarginRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e87 = function e(t, r) {
        return (_e87 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e87(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          LowerLimit: e.LowerLimit,
          Amount: parseFloat(e.Amount)
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.MarginBandRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e88 = function e(t, r) {
        return (_e88 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e88(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          IsMarginFactorOverrideAllowed: e.IsMarginFactorOverrideAllowed,
          MinMarginFactorOverrideAmount: parseFloat(e.MinMarginFactorOverrideAmount)
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.MarginSettingsRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e89 = function e(t, r) {
        return (_e89 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e89(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(30),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.spreadRestDeserialiser = new o.SpreadRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key,
          MarketKey: e.MarketKey,
          Bid: parseFloat(e.Bid),
          Ask: parseFloat(e.Ask),
          High: parseFloat(e.High),
          Low: parseFloat(e.Low),
          ChangeOnDay: parseFloat(e.ChangeOnDay),
          ChangeOnDayPercentage: parseFloat(e.ChangeOnDayPercentage),
          Spread: this.spreadRestDeserialiser.deserialise(e.Spread)
        };
      }, t;
    }(i.RestDeserialiser);

    t.MarketPriceRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e90 = function e(t, r) {
        return (_e90 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e90(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          LowerLimit: e.LowerLimit,
          Amount: parseFloat(e.Amount)
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.SpreadBandRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e91 = function e(t, r) {
        return (_e91 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e91(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          BreakStart: e.BreakStart,
          BreakEnd: e.BreakEnd
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.UnderlyingBreakRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e92 = function e(t, r) {
        return (_e92 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e92(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(29),
        a = r(152),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.marketPriceSummaryRestDeserialiser = new a.MarketPriceSummaryRestDeserialiser(), t.marketBookingStatusRestDeserialiser = new o.MarketBookingStatusRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key,
          Name: e.Name,
          DecimalPlaces: e.DecimalPlaces,
          BetPer: parseFloat(e.BetPer),
          TradeViaApi: e.TradeViaApi,
          ExchangeKey: e.ExchangeKey,
          MarketType: e.MarketType,
          SettlementType: e.SettlementType,
          Price: this.marketPriceSummaryRestDeserialiser.deserialise(e.Price),
          Accepts: this.marketBookingStatusRestDeserialiser.deserialise(e.Accepts)
        };
      }, t;
    }(i.RestDeserialiser);

    t.MarketSummaryRestDeserialiser = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e93 = function e(t, r) {
        return (_e93 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e93(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(30),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.spreadRestDeserialiser = new o.SpreadRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key,
          Bid: parseFloat(e.Bid),
          Ask: parseFloat(e.Ask),
          ChangeOnDay: parseFloat(e.ChangeOnDay),
          ChangeOnDayPercentage: parseFloat(e.ChangeOnDayPercentage),
          High: parseFloat(e.High),
          Low: parseFloat(e.Low),
          Spread: this.spreadRestDeserialiser.deserialise(e.Spread)
        };
      }, t;
    }(i.RestDeserialiser);

    t.MarketPriceSummaryRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.convertGetCandlesRequestToQuery = function (e) {
      var t = e.period,
          r = e.marketKey,
          n = e;
      if (void 0 !== n.count) return {
        time: n.time,
        count: n.count.toString(),
        period: t.toString(),
        marketKey: r
      };
      var i = e;
      return {
        start: i.start,
        end: i.end,
        period: t.toString(),
        marketKey: r
      };
    };
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e94 = function e(t, r) {
        return (_e94 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e94(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
        i = this && this.__awaiter || function (e, t, r, n) {
      return new (r || (r = Promise))(function (i, o) {
        function a(e) {
          try {
            u(n.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(n.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((n = n.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var r,
          n,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = function (e) {
      function t() {
        return e.call(this, "", "") || this;
      }

      return n(t, e), t.prototype.requestWrappedInApiResponse = function (e, t) {
        return i(this, void 0, void 0, function () {
          return o(this, function (e) {
            throw new Error("authenticate() must be called first");
          });
        });
      }, t.prototype.requestCollectionOfApiResponses = function (e, t) {
        return i(this, void 0, void 0, function () {
          return o(this, function (e) {
            throw new Error("authenticate() must be called first");
          });
        });
      }, t.prototype.request = function (e, t) {
        return i(this, void 0, void 0, function () {
          return o(this, function (e) {
            throw new Error("authenticate() must be called first");
          });
        });
      }, t.prototype.requestWithoutResponse = function (e) {
        return i(this, void 0, void 0, function () {
          return o(this, function (e) {
            throw new Error("authenticate() must be called first");
          });
        });
      }, t;
    }(r(26).AuthenticatedRequester);

    t.ThrowingRequester = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e95 = function e(t, r) {
        return (_e95 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e95(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key,
          CashBalance: parseFloat(e.CashBalance),
          OpenPnl: parseFloat(e.OpenPnl),
          NetEquity: parseFloat(e.NetEquity),
          MarginRequirement: parseFloat(e.MarginRequirement),
          AvailableBalance: parseFloat(e.AvailableBalance),
          Credit: parseFloat(e.Credit),
          WaivedDeposit: parseFloat(e.WaivedDeposit),
          TotalPosition: parseFloat(e.TotalPosition),
          NetOpenPositionLimit: null !== e.NetOpenPositionLimit ? parseFloat(e.NetOpenPositionLimit) : void 0,
          NetOpenPosition: parseFloat(e.NetOpenPosition)
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.AccountResourcesRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e96 = function e(t, r) {
        return (_e96 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e96(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.positionKeyKey = "pk.k", t.accountKey = "ak", t.tradingAccountKey = "tak", t.marketKey = "mk", t.marketName = "mn", t.quantity = "q", t.currentPrice = "cp", t.openPnL = "opl", t.currencyId = "cid", t.marginRequirement = "mr", t.status = "s", t.bookingPrice = "bp", t.command = "command", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.positionKeyKey, this.accountKey, this.tradingAccountKey, this.marketKey, this.marketName, this.quantity, this.currentPrice, this.openPnL, this.currencyId, this.marginRequirement, this.status, this.bookingPrice, this.command];
      }, t;
    }(r(5).FieldNameProvider);

    t.PositionFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e97 = function e(t, r) {
        return (_e97 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e97(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = {
          Key: this.getWrappedValue(this.fieldNameProvider.positionKeyKey, e, this.getString)
        },
            r = {
          PositionKey: this.getWrappedInIntermediateProperty(t),
          AccountKey: this.getWrappedValue(this.fieldNameProvider.accountKey, e, this.getString),
          TradingAccountKey: this.getWrappedValue(this.fieldNameProvider.tradingAccountKey, e, this.getString),
          MarketKey: this.getWrappedValue(this.fieldNameProvider.marketKey, e, this.getString),
          MarketName: this.getWrappedValue(this.fieldNameProvider.marketName, e, this.getString),
          Quantity: this.getWrappedValue(this.fieldNameProvider.quantity, e, this.getNumber),
          CurrentPrice: this.getWrappedValue(this.fieldNameProvider.currentPrice, e, this.getNumber),
          OpenPnL: this.getWrappedValue(this.fieldNameProvider.openPnL, e, this.getNumber),
          CurrencyId: this.getWrappedValue(this.fieldNameProvider.currencyId, e, this.getInt),
          MarginRequirement: this.getWrappedValue(this.fieldNameProvider.marginRequirement, e, this.getNumber),
          Status: this.getWrappedValue(this.fieldNameProvider.status, e, this.getPositionStatus),
          BookingPrice: this.getWrappedValue(this.fieldNameProvider.bookingPrice, e, this.getNumber)
        };
        return this.getDeserialisationResult(r, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.PositionDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e98 = function e(t, r) {
        return (_e98 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e98(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(3),
        o = r(10),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataCombiner = new o.InstructionKeyDataCombiner(), t;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        var r = this;
        return {
          PositionKey: this.combineSubObject(t.PositionKey, e.PositionKey, function (e, t) {
            return r.instructionKeyDataCombiner.combine(e, t);
          }),
          AccountKey: this.combineProperty(t.AccountKey, e.AccountKey),
          TradingAccountKey: this.combineProperty(t.TradingAccountKey, e.TradingAccountKey),
          MarketKey: this.combineProperty(t.MarketKey, e.MarketKey),
          MarketName: this.combineProperty(t.MarketName, e.MarketName),
          Quantity: this.combineProperty(t.Quantity, e.Quantity),
          CurrentPrice: this.combineProperty(t.CurrentPrice, e.CurrentPrice),
          OpenPnL: this.combineProperty(t.OpenPnL, e.OpenPnL),
          CurrencyId: this.combineProperty(t.CurrencyId, e.CurrencyId),
          MarginRequirement: this.combineProperty(t.MarginRequirement, e.MarginRequirement),
          Status: this.combineProperty(t.Status, e.Status),
          BookingPrice: this.combineProperty(t.BookingPrice, e.BookingPrice)
        };
      }, t;
    }(i.PushDataCombiner);

    t.PositionDataCombiner = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e99 = function e(t, r) {
        return (_e99 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e99(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = r(7),
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyDataTransformer = new a.InstructionKeyDataTransformer(), t;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.PositionKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.AccountKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.TradingAccountKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarketName) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Quantity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrentPrice) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OpenPnL) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarginRequirement) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Status) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.BookingPrice)) return {
          PositionKey: this.instructionKeyDataTransformer.transform(e.PositionKey.property),
          AccountKey: e.AccountKey.property,
          TradingAccountKey: e.TradingAccountKey.property,
          MarketKey: e.MarketKey.property,
          MarketName: e.MarketName.property,
          Quantity: e.Quantity.property,
          CurrentPrice: e.CurrentPrice.property,
          OpenPnL: e.OpenPnL.property,
          CurrencyId: e.CurrencyId.property,
          MarginRequirement: e.MarginRequirement.property,
          Status: e.Status.property,
          BookingPrice: e.BookingPrice.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.PositionDataTransformer = s;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e100 = function e(t, r) {
        return (_e100 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e100(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(6),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new o.InstructionKeyRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          PositionKey: this.instructionKeyRestDeserialiser.deserialise(e.PositionKey),
          AccountKey: e.AccountKey,
          TradingAccountKey: e.TradingAccountKey,
          MarketKey: e.MarketKey,
          MarketName: e.MarketName,
          Quantity: parseFloat(e.Quantity),
          CurrentPrice: parseFloat(e.CurrentPrice),
          OpenPnL: parseFloat(e.OpenPnL),
          CurrencyId: e.CurrencyId,
          MarginRequirement: parseFloat(e.MarginRequirement),
          Status: e.Status,
          BookingPrice: parseFloat(e.BookingPrice)
        };
      }, t;
    }(i.RestDeserialiser);

    t.PositionRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e101 = function e(t, r) {
        return (_e101 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e101(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.tradingAccountKey = "tak", t.accountKey = "ak", t.currencyId = "cid", t.cashBalance = "cb", t.marginRequirement = "mr", t.openPnl = "op", t.netEquity = "ne", t.netOpenPosition = "nop", t.command = "command", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.tradingAccountKey, this.accountKey, this.currencyId, this.cashBalance, this.marginRequirement, this.openPnl, this.netEquity, this.netOpenPosition, this.command];
      }, t;
    }(r(5).FieldNameProvider);

    t.TradingAccountResourcesFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e102 = function e(t, r) {
        return (_e102 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e102(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = {
          Key: this.getWrappedValue(this.fieldNameProvider.tradingAccountKey, e, this.getString),
          AccountKey: this.getWrappedValue(this.fieldNameProvider.accountKey, e, this.getString),
          CurrencyId: this.getWrappedValue(this.fieldNameProvider.currencyId, e, this.getInt),
          CashBalance: this.getWrappedValue(this.fieldNameProvider.cashBalance, e, this.getNumber),
          MarginRequirement: this.getWrappedValue(this.fieldNameProvider.marginRequirement, e, this.getNumber),
          OpenPnl: this.getWrappedValue(this.fieldNameProvider.openPnl, e, this.getNumber),
          NetEquity: this.getWrappedValue(this.fieldNameProvider.netEquity, e, this.getNumber),
          NetOpenPosition: this.getWrappedValue(this.fieldNameProvider.netOpenPosition, e, this.getNumber)
        };
        return this.getDeserialisationResult(t, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.TradingAccountResourcesDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e103 = function e(t, r) {
        return (_e103 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e103(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Key: this.combineProperty(t.Key, e.Key),
          AccountKey: this.combineProperty(t.AccountKey, e.AccountKey),
          CurrencyId: this.combineProperty(t.CurrencyId, e.CurrencyId),
          CashBalance: this.combineProperty(t.CashBalance, e.CashBalance),
          MarginRequirement: this.combineProperty(t.MarginRequirement, e.MarginRequirement),
          OpenPnl: this.combineProperty(t.OpenPnl, e.OpenPnl),
          NetEquity: this.combineProperty(t.NetEquity, e.NetEquity),
          NetOpenPosition: this.combineProperty(t.NetOpenPosition, e.NetOpenPosition)
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.TradingAccountResourcesDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e104 = function e(t, r) {
        return (_e104 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e104(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Key) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.AccountKey) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CurrencyId) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.CashBalance) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.MarginRequirement) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.OpenPnl) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.NetEquity) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.NetOpenPosition)) return {
          Key: e.Key.property,
          AccountKey: e.AccountKey.property,
          CurrencyId: e.CurrencyId.property,
          CashBalance: e.CashBalance.property,
          MarginRequirement: e.MarginRequirement.property,
          OpenPnl: e.OpenPnl.property,
          NetEquity: e.NetEquity.property,
          NetOpenPosition: e.NetOpenPosition.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.TradingAccountResourcesDataTransformer = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e105 = function e(t, r) {
        return (_e105 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e105(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key,
          AccountKey: e.AccountKey,
          CurrencyId: e.CurrencyId,
          CashBalance: parseFloat(e.CashBalance),
          MarginRequirement: parseFloat(e.MarginRequirement),
          OpenPnl: parseFloat(e.OpenPnl),
          NetEquity: parseFloat(e.NetEquity),
          NetOpenPosition: parseFloat(e.NetOpenPosition)
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.TradingAccountResourcesRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e106 = function e(t, r) {
        return (_e106 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e106(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(167),
        a = r(169),
        s = r(172),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.historicalTradeRestDeserialiser = new o.HistoricalTradeRestDeserialiser(), t.postingRestDeserialiser = new a.PostingRestDeserialiser(), t.tradeMatchRestDeserialiser = new s.TradeMatchRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          Trades: e.Trades.map(function (e) {
            return t.historicalTradeRestDeserialiser.deserialise(e);
          }),
          Postings: e.Postings.map(function (e) {
            return t.postingRestDeserialiser.deserialise(e);
          }),
          TradeMatches: e.TradeMatches.map(function (e) {
            return t.tradeMatchRestDeserialiser.deserialise(e);
          })
        };
      }, t;
    }(i.RestDeserialiser);

    t.HistoricalTradeResponseRestDeserialiser = u;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e107 = function e(t, r) {
        return (_e107 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e107(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(12),
        a = r(6),
        s = r(31),
        u = r(168),
        c = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new a.InstructionKeyRestDeserialiser(), t.sourceRestDeserialiser = new s.SourceRestDeserialiser(), t.historicalOrderRestDeserialiser = new u.HistoricalOrderRestDeserialiser(), t.considerationRestDeserialiser = new o.ConsiderationRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          InstructionKey: this.instructionKeyRestDeserialiser.deserialise(e.InstructionKey),
          BookingTime: new Date(e.BookingTime),
          BookingPrice: parseFloat(e.BookingPrice),
          Reference: e.Reference,
          OriginalQuantity: parseFloat(e.OriginalQuantity),
          Source: this.sourceRestDeserialiser.deserialise(e.Source),
          MarketKey: e.MarketKey,
          MarketName: e.MarketName,
          CurrencyId: e.CurrencyId,
          ClientRequestId: e.ClientRequestId,
          ClientRequestReference: e.ClientRequestReference,
          Orders: e.Orders.map(function (e) {
            return t.historicalOrderRestDeserialiser.deserialise(e);
          }),
          ValueDate: null !== e.ValueDate ? new Date(e.ValueDate) : void 0,
          Consideration: this.considerationRestDeserialiser.deserialise(e.Consideration)
        };
      }, t;
    }(i.RestDeserialiser);

    t.HistoricalTradeRestDeserialiser = c;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e108 = function e(t, r) {
        return (_e108 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e108(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(6),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new o.InstructionKeyRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          InstructionKey: this.instructionKeyRestDeserialiser.deserialise(e.InstructionKey),
          MarketKey: e.MarketKey,
          MarketName: e.MarketName,
          OrderType: e.OrderType,
          Quantity: parseFloat(e.Quantity),
          TriggerPrice: parseFloat(e.TriggerPrice),
          Status: e.Status,
          TriggeringTime: null !== e.TriggeringTime ? new Date(e.TriggeringTime) : void 0,
          CurrencyId: e.CurrencyId,
          Level: parseFloat(e.Level),
          BookingDate: new Date(e.BookingDate),
          Reference: e.Reference,
          ExpiryDateTime: null !== e.ExpiryDateTime ? new Date(e.ExpiryDateTime) : void 0,
          ContingentLimitDistance: null !== e.ContingentLimitDistance ? parseFloat(e.ContingentLimitDistance) : void 0,
          ContingentStopDistance: null !== e.ContingentStopDistance ? parseFloat(e.ContingentStopDistance) : void 0,
          ContingentIsGuaranteedStop: e.ContingentIsGuaranteedStop,
          CancelledDate: null !== e.CancelledDate ? new Date(e.CancelledDate) : void 0,
          ClientRequestId: e.ClientRequestId,
          ClientRequestReference: e.ClientRequestReference
        };
      }, t;
    }(i.RestDeserialiser);

    t.HistoricalOrderRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e109 = function e(t, r) {
        return (_e109 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e109(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(170),
        a = r(6),
        s = r(171),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new a.InstructionKeyRestDeserialiser(), t.postingTypeRestDeserialiser = new s.PostingTypeRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        if (o.isConvertedTradePostingRestResponse(e)) return this.deserialiseConvertedTradePosting(e);
        if (o.isTradePostingRestResponse(e)) return this.deserialiseTradePosting(e);
        if (o.isConvertedTradeMatchPostingRestResponse(e)) return this.deserialiseConvertedTradeMatchPosting(e);
        if (o.isTradeMatchPostingRestResponse(e)) return this.deserialiseTradeMatchPosting(e);
        throw Error("Unknown posting rest response data: " + e);
      }, t.prototype.deserialiseTradePosting = function (e) {
        return {
          Key: e.Key,
          Amount: parseFloat(e.Amount),
          PostingType: this.postingTypeRestDeserialiser.deserialise(e.PostingType),
          PostingDate: new Date(e.PostingDate),
          TradeKey: this.instructionKeyRestDeserialiser.deserialise(e.TradeKey)
        };
      }, t.prototype.deserialiseConvertedTradePosting = function (e) {
        return {
          Key: e.Key,
          Amount: parseFloat(e.Amount),
          PostingType: this.postingTypeRestDeserialiser.deserialise(e.PostingType),
          PostingDate: new Date(e.PostingDate),
          TradeKey: this.instructionKeyRestDeserialiser.deserialise(e.TradeKey),
          FxRate: parseFloat(e.FxRate)
        };
      }, t.prototype.deserialiseTradeMatchPosting = function (e) {
        return {
          Key: e.Key,
          Amount: parseFloat(e.Amount),
          PostingType: this.postingTypeRestDeserialiser.deserialise(e.PostingType),
          PostingDate: new Date(e.PostingDate),
          TradeMatchKey: e.TradeMatchKey
        };
      }, t.prototype.deserialiseConvertedTradeMatchPosting = function (e) {
        return {
          Key: e.Key,
          Amount: parseFloat(e.Amount),
          PostingType: this.postingTypeRestDeserialiser.deserialise(e.PostingType),
          PostingDate: new Date(e.PostingDate),
          TradeMatchKey: e.TradeMatchKey,
          FxRate: parseFloat(e.FxRate)
        };
      }, t;
    }(i.RestDeserialiser);

    t.PostingRestDeserialiser = u;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      var t = e;
      return void 0 !== t.Key && void 0 !== t.Amount && void 0 !== t.PostingType && void 0 !== t.PostingDate;
    }

    function i(e) {
      var t = e;
      return n(t) && void 0 !== t.TradeKey;
    }

    function o(e) {
      var t = e;
      return n(t) && void 0 !== t.TradeMatchKey;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isPostingRestResponse = n, t.isTradePostingRestResponse = i, t.isTradeMatchPostingRestResponse = o, t.isConvertedTradePostingRestResponse = function (e) {
      var t = e;
      return i(t) && void 0 !== t.FxRate;
    }, t.isConvertedTradeMatchPostingRestResponse = function (e) {
      var t = e;
      return o(t) && void 0 !== t.FxRate;
    };
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e110 = function e(t, r) {
        return (_e110 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e110(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.PostingTypeRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e111 = function e(t, r) {
        return (_e111 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e111(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(6),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new o.InstructionKeyRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          OpeningTradeKey: this.instructionKeyRestDeserialiser.deserialise(e.OpeningTradeKey),
          ClosingTradeKey: this.instructionKeyRestDeserialiser.deserialise(e.ClosingTradeKey),
          MatchQuantity: parseFloat(e.MatchQuantity),
          Key: e.Key
        };
      }, t;
    }(i.RestDeserialiser);

    t.TradeMatchRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e112 = function e(t, r) {
        return (_e112 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e112(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key,
          Date: new Date(e.Date),
          Period: e.Period,
          FileName: e.FileName,
          FileSize: e.FileSize
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.StatementRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e113 = function e(t, r) {
        return (_e113 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e113(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.key = "k", t.fromCurrency = "fc", t.toCurrency = "tc", t.rate = "r", t.command = "command", t;
      }

      return n(t, e), t.prototype.getFieldNames = function () {
        return [this.itemKey, this.sequenceNumberEra, this.sequenceNumberNumber, this.key, this.fromCurrency, this.toCurrency, this.rate, this.command];
      }, t;
    }(r(5).FieldNameProvider);

    t.ExchangeRateFieldNameProvider = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e114 = function e(t, r) {
        return (_e114 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e114(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = {
          Key: this.getWrappedValue(this.fieldNameProvider.key, e, this.getString),
          FromCurrency: this.getWrappedValue(this.fieldNameProvider.fromCurrency, e, this.getInt),
          ToCurrency: this.getWrappedValue(this.fieldNameProvider.toCurrency, e, this.getInt),
          Rate: this.getWrappedValue(this.fieldNameProvider.rate, e, this.getNumber)
        };
        return this.getDeserialisationResult(t, e);
      }, t;
    }(r(4).PushDeserialiser);

    t.ExchangeRateDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e115 = function e(t, r) {
        return (_e115 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e115(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.combine = function (e, t) {
        return {
          Key: this.combineProperty(t.Key, e.Key),
          FromCurrency: this.combineProperty(t.FromCurrency, e.FromCurrency),
          ToCurrency: this.combineProperty(t.ToCurrency, e.ToCurrency),
          Rate: this.combineProperty(t.Rate, e.Rate)
        };
      }, t;
    }(r(3).PushDataCombiner);

    t.ExchangeRateDataCombiner = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e116 = function e(t, r) {
        return (_e116 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e116(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(2),
        o = r(1),
        a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.transform = function (e) {
        if (o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Key) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.FromCurrency) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.ToCurrency) && o.ChangedIntermediateProperty.isChangedIntermediateProperty(e.Rate)) return {
          Key: e.Key.property,
          FromCurrency: e.FromCurrency.property,
          ToCurrency: e.ToCurrency.property,
          Rate: e.Rate.property
        };
        throw new Error("Tried to transform intermediate where not all data was present");
      }, t;
    }(i.DataTransformer);

    t.ExchangeRateDataTransformer = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e117 = function e(t, r) {
        return (_e117 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e117(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          Key: e.Key,
          FromCurrency: e.FromCurrency,
          ToCurrency: e.ToCurrency,
          Rate: parseFloat(e.Rate)
        };
      }, t;
    }(r(0).RestDeserialiser);

    t.ExchangeRateRestDeserialiser = i;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e118 = function e(t, r) {
        return (_e118 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e118(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(180),
        a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.foundTradeRestDeserialiser = new o.FoundTradeRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        var t = this;
        return {
          Trades: e.Trades.map(function (e) {
            return t.foundTradeRestDeserialiser.deserialise(e);
          })
        };
      }, t;
    }(i.RestDeserialiser);

    t.TradeSearchResponseRestDeserialiser = a;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__extends || function () {
      var _e119 = function e(t, r) {
        return (_e119 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(t, r);
      };

      return function (t, r) {
        function n() {
          this.constructor = t;
        }

        _e119(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }();

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(0),
        o = r(12),
        a = r(6),
        s = r(31),
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.instructionKeyRestDeserialiser = new a.InstructionKeyRestDeserialiser(), t.sourceRestDeserialiser = new s.SourceRestDeserialiser(), t.considerationRestDeserialiser = new o.ConsiderationRestDeserialiser(), t;
      }

      return n(t, e), t.prototype.deserialise = function (e) {
        return {
          InstructionKey: this.instructionKeyRestDeserialiser.deserialise(e.InstructionKey),
          BookingTime: new Date(e.BookingTime),
          BookingPrice: parseFloat(e.BookingPrice),
          Reference: e.Reference,
          OriginalQuantity: parseFloat(e.OriginalQuantity),
          Source: this.sourceRestDeserialiser.deserialise(e.Source),
          MarketKey: e.MarketKey,
          MarketName: e.MarketName,
          CurrencyId: e.CurrencyId,
          ValueDate: null !== e.ValueDate ? new Date(e.ValueDate) : void 0,
          Consideration: this.considerationRestDeserialiser.deserialise(e.Consideration),
          SubType: e.SubType
        };
      }, t;
    }(i.RestDeserialiser);

    t.FoundTradeRestDeserialiser = u;
  }]);
});